export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2024-08-29T04:43:11.765Z",
    "Language": "pl-PL",
    "Messages": {
        "3": "",
        "5": "",
        "10": "",
        "-": "",
        "...nie znalazłeś treści? Utwórz nową.": "",
        "{count} odpowiedzi": "",
        "{seconds} sek.": "",
        "1. Wybierz wzór": "",
        "2 kolumny 25/75": "",
        "2 kolumny 33/66": "",
        "2 kolumny 50/50": "",
        "2 kolumny 66/33": "",
        "2 kolumny 75/25": "",
        "2. Wybierz wpis": "",
        "3 kolumny": "",
        "3 kolumny 25/25/50": "",
        "3 kolumny 25/50/25": "",
        "3 kolumny 50/25/25": "",
        "3. Konfiguruj i wstaw": "",
        "4 kolumny": "",
        "A11y": "",
        "A11y i SEO": "",
        "Aby nastąpiła automatyczna akceptacja regulaminu, wybrana wersja musi mieć status „Do akceptacji”.": "",
        "Adres": "",
        "Adres docelowy": "",
        "Adres domenowy": "",
        "Adres domeny": "",
        "Adres e-mail": "",
        "Adres IP": "",
        "Adres kanoniczny": "",
        "Adres linku": "",
        "Adres otwierany po kliknięciu bannera.": "",
        "Adres strony": "",
        "Adres tematu oraz jego zasięg.": "",
        "Adres url": "",
        "Adres URL": "",
        "Adres url do pliku wideo": "",
        "Adres URL profilu autora.": "",
        "Adres został skopiowany.": "",
        "Adres źródłowy": "",
        "Adresy w obrębie tej samej domeny podawaj jako pełne ścieżki, np. /stara-strona oraz /nowa-strona.": "",
        "Adresy witryny korzystają z HTTPS zamiast HTTP.": "",
        "AI": "",
        "AI w wynikach Google Search": "",
        "Akceptacja komentarzy": "",
        "Akceptuj": "",
        "Akcje ceny": "",
        "Akcje listy: {name}": "",
        "Akcje sekcji": "",
        "Akcje treści": "",
        "Akcje widżetu": "",
        "Akcje widżetu {name}": "",
        "Aktualna": "",
        "Aktualności": "",
        "Aktualności ze strony": "",
        "Aktywacja kont po rejestracji": "",
        "Aktywna": "",
        "Aktywne": "",
        "Aktywne do": "",
        "Aktywne kanały:": "",
        "Aktywne od": "",
        "Aktywne teraz": "",
        "Aktywni użytkownicy": "",
        "Aktywność użytkowników w ostatnich 30 minutach": "",
        "Aktywny": "",
        "Aktywuj": "",
        "Aktywuj przerwę techniczną w witrynie": "",
        "Alfabetycznie": "",
        "Alternatywna": "",
        "Angielski": "",
        "Ankieta": "",
        "Ankieta dołączona do artykułu": "",
        "Ankieta nie ma jeszcze głosów": "",
        "Ankieta wyświetli się w miejscu wskazanym w treści artykułu. Aby je wskazać wybierz element \"Ankieta\" z narzędzi edytora": "",
        "Ankiety": "",
        "Anulowane": "",
        "Anuluj": "",
        "Anuluj edycję": "",
        "Aranżacja": "",
        "Aranżacja alternatywna": "",
        "Aranżacja domyślna": "",
        "Aranżacja główna": "",
        "Aranżacja i moduł": "",
        "Aranżacja nie jest przypisana do żadnej strony": "",
        "Aranżacja została dodana.": "",
        "Aranżacja została skopiowana.": "",
        "Aranżacja została usunięta.": "",
        "Aranżacja została zaktualizowana.": "",
        "Aranżacje": "",
        "Aranżacje docelowe": "",
        "Archiwum": "",
        "artykuł": "",
        "Artykuł": "",
        "Artykuł na całą szerokość": "",
        "Artykuł otwarty": "",
        "Artykuł premium": "",
        "Artykuł sponsorowany": "",
        "artykułów": "",
        "artykuły": "",
        "Artykuły": "",
        "Artykuły oznaczone jako \"Śródtekstowe\" wyświetlą się w miejscu wskazanym w treści artykułu. Aby je wskazać wybierz element \"Powiązane artykuły\" z narzędzi edytora": "",
        "Artykuły ze statusem PRIORYTET": "",
        "Asystent AI": "",
        "Asystent nie zwrócił treści. Spróbuj ponownie.": "",
        "Asystent odpowie na podstawie treści artykułu – możesz też poprosić o przeredagowanie zaznaczonego fragmentu.": "",
        "Automat paczkowy": "",
        "Automatyczna akceptacja": "",
        "Automatyczna akceptacja komentarzy zalogowanych": "",
        "Automatyczna akceptacja wszystkich komentarzy": "",
        "Automatyczna publikacja galerii": "",
        "Automatyczna publikacja wideo": "",
        "Automatyczne anulowanie zamówienia.": "",
        "Automatyczny": "",
        "Automatyczny przewodnik po treściach witryny dla narzędzi AI.": "",
        "Autor": "",
        "Autor będzie powiązany z kontem w panelu.": "",
        "Autor komentarza": "",
        "Autor nie może zostać usunięty, ponieważ jest przypisany do artykułów": "",
        "Autor został dodany.": "",
        "Autor został usunięty.": "",
        "Autor został zaktualizowany.": "",
        "Autorzy": "",
        "Autorzy spoza bazy użytkowników": "",
        "Baner został dodany.": "",
        "Baner został zaktualizowany.": "",
        "Banery": "",
        "Banner został usunięty.": "",
        "Barwa tekstu": "",
        "Barwa tła": "",
        "Baza dokumentów": "",
        "Bez \"http(s)://\" i \"/\" na końcu.": "",
        "Bez autora": "",
        "Bez modułu": "",
        "Bez witryny": "",
        "Bezpieczeństwo": "",
        "Bezpieczny adres URL": "",
        "bieżąca": "",
        "Błąd 404": "",
        "Błąd płatności": "",
        "Błąd renderowania bloku": "",
        "Blik": "",
        "blisko limitu": "",
        "Blokada /api/*, reguły przełączników AI i adresy sitemapy są dodawane automatycznie. Własne wpisy są z nimi łączone; reguły Allow mogą zmienić zakres blokad.": "",
        "Brak": "",
        "Brak akcji w tej sesji.": "",
        "Brak artykułów w czołówce.": "",
        "Brak czołówki": "",
        "Brak danych": "",
        "Brak danych do faktury.": "",
        "Brak dodanych plików": "",
        "Brak dostępnej opublikowanej wersji tej aranżacji.": "",
        "Brak dostępnych typów aranżacji": "",
        "Brak dostępnych typów widgetów.": "",
        "Brak etykiety": "",
        "Brak historii cen.": "",
        "Brak innych aranżacji zawierających tę sekcję.": "",
        "Brak kategorii": "",
        "Brak kategorii nadrzędnej": "",
        "Brak kategorii.": "",
        "Brak komentarzy w tej zakładce.": "",
        "Brak listy regulaminów": "",
        "Brak modułu": "",
        "Brak odpowiedzi": "",
        "Brak odrzuconych zgód": "",
        "Brak opinii": "",
        "Brak parametrów konfiguracji": "",
        "Brak pasujących aranżacji": "",
        "Brak pasujących sekcji": "",
        "Brak pasujących widżetów": "",
        "brak pól": "",
        "Brak potwierdzenia": "",
        "Brak powiązań": "",
        "Brak powiązanych artykułów.": "",
        "Brak pozycji.": "",
        "Brak przypisanych regulaminów.": "",
        "Brak regulaminów do zaakceptowania.": "",
        "Brak sekcji": "",
        "Brak sekcji szablonu": "",
        "Brak sitemap.": "",
        "Brak slajdów": "",
        "Brak stron": "",
        "Brak stron dostępnych dla wybranej witryny i języka.": "",
        "Brak stron w katalogu": "",
        "Brak strony nadrzędnej": "",
        "Brak uprawnień": "",
        "Brak uprawnień do edycji grupy banerów.": "",
        "Brak uprawnień do usuwania linków wewnętrznych.": "",
        "Brak uprawnień do usuwania subskrypcji.": "",
        "Brak uprawnień do usuwania top tematów.": "",
        "Brak użytkownika na liście oznacza, że jego imię lub nazwisko należy uzupełnić w dziale Użytkownicy.": "",
        "Brak widgetów w tym regionie.": "",
        "Brak widżetów pasujących do wyszukiwania.": "",
        "Brak widżetów tego typu": "",
        "Brak wpisów do edycji": "",
        "Brak wybranych autorów": "",
        "Brak wyrażonych zgód": "",
        "Brak zamówień.": "",
        "Brak zestawów spełniających kryteria.": "",
        "Brak zgłoszeń": "",
        "brak zmian w polach": "",
        "Brakuje obszaru na główną treść strony, np. artykuł. Wybierz szablon z obszarem „Treść modułu” lub dodaj go w konfiguracji szablonu.": "",
        "Browse files": "",
        "Browse links": "",
        "Cache": "",
        "Cała zawartość jest projektowana w PageBuilderze. Strona nie korzysta z modułu ani aranżacji CMS.": "",
        "Cel i zasięg": "",
        "Cena": "",
        "Cena brutto": "",
        "Cena została wyłączona z historii.": "",
        "Cennik": "",
        "CLS": "",
        "CMS": "",
        "Co godzinę": "",
        "Co miesiąc": "",
        "Co rok": "",
        "Co tydzień": "",
        "Codziennie": "",
        "Cofanie...": "",
        "Cofnięto operację na widgetu": "",
        "Cofnięto zmianę": "",
        "Cofnij": "",
        "Cofnij ostatnią zmianę inline": "",
        "Cykl życia zamówienia": "",
        "Czas na slajd": "",
        "Czas na stronie": "",
        "Czas po jakim zamówienie wygaśnie": "",
        "Czas po jakim zamówienie zostanie anulowane": "",
        "Czas UTC": "",
        "Czas życia": "",
        "Czekam na metryki wydajności z podglądu.": "",
        "Część zmiennych zostanie podstawiona dopiero przy renderowaniu.": "",
        "Częstotliwość odświeżania": "",
        "Częstotliwość zmian (changefreq)": "",
        "Czołówka": "",
        "Czołówka została dodana.": "",
        "Czołówka została usunięta.": "",
        "Czołówka została zaktualizowana.": "",
        "Czwartek": "",
        "Czy chcesz ją przywrócić?": "",
        "Czy na pewno chcesz usunąć tę stronę?": "",
        "Czytać mogą tylko zalogowani użytkownicy": "",
        "Dalsza część artykułu przeznaczona jest dla osób z subskrypcją premium": "",
        "Dalsze polecenie": "",
        "Dane autoryzacyjne Google Analytics": "",
        "Dane developerskie skopiowane do schowka.": "",
        "Dane do faktury": "",
        "Dane klienta": "",
        "Dane wpisu": "",
        "Dane wzoru": "",
        "Data": "",
        "Data akceptacji": "",
        "Data automatycznej akceptacji": "",
        "Data dezaktywacji": "",
        "Data do": "",
        "Data dodania": "",
        "Data i czas – 2026-09-04T14:30:00Z": "",
        "Data i godzina": "",
        "Data informująca o terminie wejścia w życie tego regulaminu.": "",
        "Data modyfikacji": "",
        "Data od": "",
        "Data odrzucenia": "",
        "Data opłacenia": "",
        "Data publikacji": "",
        "Data publikacji regulaminu": "",
        "Data publikacji slajdera": "",
        "Data rezygnacji": "",
        "Data rozpoczęcia": "",
        "Data wydania": "",
        "Data wygaśnięcia": "",
        "Data zakończenia": "",
        "Data zakończenia publikacji nie może być wcześniejsza, niż jej rozpoczęcie": "",
        "Data zapisania się": "",
        "Data zgłoszenia": "",
        "Daty": "",
        "Daty publikacji": "",
        "Daty publikacji zostały zaktualizowane.": "",
        "Definicja szablonu": "",
        "Desktop": "",
        "Dev": "",
        "Dezaktywuj": "",
        "Diagnostyka": "",
        "Dla procesu zakupowego": "",
        "Długość": "",
        "Długość mieści się w zalecanym limicie.": "",
        "Długość zależy od podstawionej wartości.": "",
        "dni": "",
        "Dni": "",
        "Do odebrania w punkcie": "",
        "Do poziomu": "",
        "Docelowa strona": "",
        "Dodaj": "",
        "Dodaj aranżację": "",
        "Dodaj artykuł": "",
        "Dodaj autora": "",
        "Dodaj baner": "",
        "Dodaj czołówkę": "",
        "Dodaj definicję szablonu, aby skonfigurować jego sekcje.": "",
        "Dodaj dokument": "",
        "Dodaj element": "",
        "Dodaj etykietę": "",
        "Dodaj galerię": "",
        "Dodaj gazetkę": "",
        "Dodaj grupę": "",
        "Dodaj katalog": "",
        "Dodaj kategorie": "",
        "Dodaj kategorię": "",
        "Dodaj konkretny przykład zastosowania": "",
        "Dodaj link": "",
        "Dodaj nofollow": "",
        "Dodaj nowa kategorię": "",
        "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "",
        "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "",
        "Dodaj nowy tag": "",
        "Dodaj nowy widżet, podając jego nazwę poniżej.": "",
        "Dodaj odpowiedź": "",
        "Dodaj opinię": "",
        "Dodaj pierwszy slajd, aby uzupełnić obrazy i treść.": "",
        "Dodaj plik": "",
        "Dodaj powiązany artykuł": "",
        "Dodaj powiązany rekord": "",
        "Dodaj powód": "",
        "Dodaj przekierowanie": "",
        "Dodaj publikację": "",
        "Dodaj pytanie": "",
        "Dodaj rotator": "",
        "Dodaj sekcję": "",
        "Dodaj sekcję z kolumnami – w aranżacjach redaktorzy umieszczą w nich widgety.": "",
        "Dodaj sekcję z kolumnami – w tych slotach redaktorzy będą umieszczać widgety w aranżacjach.": "",
        "Dodaj shortcode": "",
        "Dodaj ShortCode": "",
        "Dodaj slajd": "",
        "Dodaj slajder": "",
        "Dodaj słowo": "",
        "Dodaj stronę": "",
        "Dodaj szablon": "",
        "Dodaj treść": "",
        "Dodaj tutaj": "",
        "Dodaj typ": "",
        "Dodaj typ aranżacji": "",
        "Dodaj wideo": "",
        "Dodaj widget do sekcji": "",
        "Dodaj widget tutaj": "",
        "Dodaj widżet": "",
        "Dodaj witrynę": "",
        "Dodaj wpis": "",
        "Dodaj wybrane": "",
        "Dodaj wzór": "",
        "Dodaj zestaw": "",
        "Dodane przez": "",
        "Dodane przez moje zespoły": "",
        "Dodane przeze mnie": "",
        "Dodanie aktualności": "",
        "Dodanie ankiety": "",
        "Dodanie aranżacji": "",
        "Dodanie artykułu": "",
        "Dodanie autora": "",
        "Dodanie baneru": "",
        "Dodanie czołówki": "",
        "Dodanie dokumentu": "",
        "Dodanie etykiety": "",
        "Dodanie galerii": "",
        "Dodanie gazetki": "",
        "Dodanie grupy": "",
        "Dodanie kategorii": "",
        "Dodanie linku": "",
        "Dodanie linku wewnętrznego": "",
        "Dodanie pakietu": "",
        "Dodanie poradnika": "",
        "Dodanie regulaminu": "",
        "Dodanie rotatora": "",
        "Dodanie slajdera": "",
        "Dodanie strony": "",
        "Dodanie szablonu": "",
        "Dodanie top tematu": "",
        "Dodanie wideo": "",
        "Dodanie witryny": "",
        "Dodanie wzoru": "",
        "Dodanie zestawu regulaminów": "",
        "dodano": "",
        "Dodano widget": "",
        "Dodano za dużo stron (maksymalnie %0).": "",
        "Dodatkowe parametry w adresie URL": "",
        "Dodatkowe reguły robots.txt": "",
        "Dodawanie ankiety": "",
        "Dodawanie dokumentu": "",
        "Dodawanie galerii": "",
        "Dodawanie gazetki": "",
        "Dodawanie linku": "",
        "Dodawanie pytań i odpowiedzi": "",
        "Dodawanie rotatora": "",
        "Dodawanie tylko po zalogowaniu": "",
        "Dodawanie wideo": "",
        "Dokąd prowadzi odnośnik i gdzie obowiązuje.": "",
        "Dokument": "",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "",
        "Dokument nie ma ustawionej daty publikacji.": "",
        "Dokument został dodany.": "",
        "Dokument został usunięty.": "",
        "Dokument został w międzyczasie zmieniony przez kogoś innego.": "",
        "Dokument został w międzyczasie zmieniony przez kogoś innego. Nadpisanie zastąpi cudzą zmianę, a odświeżenie porzuci Twoją edycję i pokaże aktualne dane.": "",
        "Dokument został zaktualizowany.": "",
        "Dokumenty": "",
        "Dołącz stronę do pliku sitemap.xml": "",
        "domena witryny": "",
        "Domyślna": "",
        "Domyślna stopka": "",
        "Domyślna strona dla wybranego modułu": "",
        "Domyślna witryna": "",
        "Domyślne": "",
        "Domyślne logo": "",
        "Domyślne ustawienie dla witryny": "",
        "Domyślny": "",
        "Domyślny tytuł aktywnej strony": "",
        "Dopasowanie": "",
        "Dostarczone": "",
        "Dostawa": "",
        "Dostęp robotów AI": "",
        "Dostępna wersja robocza": "",
        "Dostępne dla": "",
        "Dostępne i opublikowane wersje językowe witryny.": "",
        "Dostępne języki": "",
        "Dostępne moduły": "",
        "Dostępne sekcje": "",
        "Dostępne wersje językowe.": "",
        "Dostępne widgety zależą od witryny, języka i szablonu.": "",
        "Dostępne widgety: {count}": "",
        "Dostępne widżety": "",
        "Dostępne wpisy: {count}": "",
        "Dostępne zmienne": "",
        "Dostępność": "",
        "Dostosuj kolumny dla tego urządzenia": "",
        "Dotyczy": "",
        "Drugi klucz - md5": "",
        "Drugie powiadomienie": "",
        "Duplikuj": "",
        "Duplikuj aranżację": "",
        "Duplikuj blok": "",
        "Dynamiczny": "",
        "Dzień tygodnia": "",
        "e-commerce": "",
        "E-mail": "",
        "Edito tworzy plik automatycznie na podstawie publicznych treści uwzględnionych w mapie witryny. Nie musisz przygotowywać ani wgrywać pliku.": "",
        "Edycja": "",
        "Edycja aktualności": "",
        "Edycja ankiety": "",
        "Edycja aranżacji": "",
        "Edycja artykułu": "",
        "Edycja autora": "",
        "Edycja baneru": "",
        "Edycja czołówki": "",
        "Edycja dokumentu": "",
        "Edycja etykiety": "",
        "Edycja galerii": "",
        "Edycja gazetki": "",
        "Edycja grupy": "",
        "Edycja kategorii": "",
        "Edycja kategorii dokumentów": "",
        "Edycja komentarza": "",
        "Edycja linku": "",
        "Edycja linku wewnętrznego": "",
        "Edycja pakietu": "",
        "Edycja poradnika": "",
        "Edycja pytań i odpowiedzi": "",
        "Edycja pytania i odpowiedzi": "",
        "Edycja regulaminu": "",
        "Edycja rotatora": "",
        "Edycja slajdera": "",
        "Edycja strony": "",
        "Edycja szablonu": "",
        "Edycja top tematu": "",
        "Edycja ustawień": "",
        "Edycja wideo": "",
        "Edycja witryny": "",
        "Edycja wzoru": "",
        "Edycja zestawu regulaminów": "",
        "Edytowano pole": "",
        "Edytuj": "",
        "Edytuj adres e-mail": "",
        "Edytuj aranżację": "",
        "Edytuj aranżację alternatywną": "",
        "Edytuj autora": "",
        "Edytuj czołówkę": "",
        "Edytuj datę": "",
        "Edytuj etykietę": "",
        "Edytuj formularz": "",
        "Edytuj kategorię": "",
        "Edytuj kolor": "",
        "Edytuj kolumny sekcji": "",
        "Edytuj komentarz": "",
        "Edytuj liczbę": "",
        "Edytuj link": "",
        "Edytuj menu": "",
        "Edytuj obszar": "",
        "Edytuj oś czasu": "",
        "Edytuj plik": "",
        "Edytuj powiązania": "",
        "Edytuj przekierowanie": "",
        "Edytuj pytanie": "",
        "Edytuj rotator": "",
        "Edytuj sekcję": "",
        "Edytuj shortcode": "",
        "Edytuj slajder": "",
        "Edytuj stronę": "",
        "Edytuj tekst": "",
        "Edytuj treść": "",
        "Edytuj widget": "",
        "Edytuj wpis": "",
        "Edytuj wstawkę": "",
        "Edytuj wybór": "",
        "Edytuj wybraną ankietę.": "",
        "Edytuj zestaw": "",
        "Edytujesz sekcję {current} z {total}.": "",
        "Eksport": "",
        "element": "",
        "elementów": "",
        "Elementy dostępne w aranżacjach tej witryny.": "",
        "Elementy osi czasu": "",
        "Email": "",
        "Email użytkownika": "",
        "Entuzjastyczny": "",
        "EQL": "",
        "etykieta": "",
        "Etykieta": "",
        "Etykieta została dodana.": "",
        "Etykieta została usunięta.": "",
        "Etykieta została zaktualizowana.": "",
        "Etykiety": "",
        "Etykiety pól na stronie": "",
        "Facebook Admins": "",
        "Facebook Application ID": "",
        "Favicona": "",
        "Film": "",
        "Film z YouTube": "",
        "Filtr audytu": "",
        "Filtry": "",
        "Finalnie:": "",
        "Finalnie: pole będzie puste.": "",
        "Firma": "",
        "Folder został usunięty.": "",
        "Forma płatności": "",
        "Formalny": "",
        "Format daty modyfikacji (lastmod)": "",
        "Format pliku": "",
        "formularz": "",
        "Formularz": "",
        "Formularz kontaktowy": "",
        "Formularz nie istnieje.": "",
        "Formularz określający pola wypełniane przy wstawianiu shortcode.": "",
        "Formularz wyświetlany pod artykułem": "",
        "Francuski": "",
        "Fraza": "",
        "Fraza podmieniana w treści na odnośnik.": "",
        "Front nie odpowiedział w wymaganym czasie.": "",
        "Front zwrócił błąd:": "",
        "Funkcje dostępne podczas tworzenia stron witryny.": "",
        "Galeria": "",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "",
        "Galeria nie ma ustawionej daty publikacji.": "",
        "Galeria zdjęć": "",
        "Galeria zdjęć premium": "",
        "Galeria została dodana.": "",
        "Galeria została usunięta.": "",
        "Galeria została zaktualizowana.": "",
        "Gazetka": "",
        "Gazetka nie jest jeszcze nigdzie opublikowana.": "",
        "Gazetka nie ma ustawionej daty publikacji.": "",
        "Gazetka została dodana.": "",
        "Gazetka została usunięta.": "",
        "Gazetka została zaktualizowana.": "",
        "Generowanie": "",
        "Generowanie sitemapów zostało zlecone. Może to potrwać kilka minut.": "",
        "Generowanie stron gazetek...": "",
        "Generowanie stron gazetki nie jest aktywne.": "",
        "Generowanie treści": "",
        "Generowanie trwa zbyt długo. Odśwież stronę, aby sprawdzić aktualny status.": "",
        "Generuj": "",
        "Generuj nowe sitemapy": "",
        "Generuj ponownie": "",
        "Generuj strony gazetki": "",
        "Generuj treść": "",
        "Generuj wszystkie metadane": "",
        "Generuję treść…": "",
        "gł.": "",
        "głos": "",
        "głosów": "",
        "Główna": "",
        "Główny nagłówek widoczny na stronie artykułu.": "",
        "godz.": "",
        "Godzina": "",
        "Google Maps": "",
        "Goście nie mogą dodawać komentarzy. Dostęp do czytania określa osobne ustawienie.": "",
        "Goście nie mogą zgłaszać komentarzy do moderacji.": "",
        "Gotowe": "",
        "Gotowe widgety: %0": "",
        "Gotowe widżety": "",
        "Grafika wyświetlana jako okładka filmu.": "",
        "Grafiki": "",
        "Granice widgetów na stronie": "",
        "Grupa": "",
        "Grupa banerów już nie istnieje.": "",
        "Grupa banerów została dodana.": "",
        "Grupa banerów została usunięta.": "",
        "Grupa banerów została zaktualizowana.": "",
        "Grupy": "",
        "Historia": "",
        "Historia wersji będzie dostępna po zapisaniu artykułu.": "",
        "Historia zmian ceny": "",
        "Historia zmian inline": "",
        "i posiadających wymagane uprawnienia": "",
        "Id": "",
        "ID": "",
        "id aktualnej rewizji": "",
        "id pierwszej wersji": "",
        "Id punktu płatności - posId": "",
        "Id wpisu": "",
        "Identyfikator aplikacji Meta powiązanej z witryną.": "",
        "Identyfikator filmu z adresu YouTube, np. część po v=.": "",
        "Identyfikator kontenera Google Tag Manager używanego w tej witrynie.": "",
        "Identyfikator OAuth używany do połączenia z PayU. Skopiuj client_id z konfiguracji punktu POS.": "",
        "Identyfikator punktu płatności w PayU. Znajdziesz go w konfiguracji punktu POS w panelu PayU.": "",
        "Identyfikator sekcji": "",
        "Identyfikator usługi Google Analytics": "",
        "Identyfikator usługi Google Analytics, z której mają być pobierane statystyki.": "",
        "Ikona": "",
        "Ikona pomagająca rozpoznać wzór podczas wyboru shortcode.": "",
        "Ikona wyświetlana jest w postaci kwadratu.": "",
        "Ile dni przed zakończeniem subskrypcji autoodnawialnej rozpocznie się pobranie płatności.": "",
        "Ile razy system ponawia nieudaną płatność.": "",
        "Ilość dni przed": "",
        "Ilość kolumn podkategorii": "",
        "Ilość powtórzeń po wystąpieniu błędu": "",
        "Ilość publikacji: %0": "",
        "Ilość wybranych stron: %0": "",
        "Ilość wyświetlanych aktualności": "",
        "Ilość wyświetlanych artykułów": "",
        "Ilość wyświetlanych tagów": "",
        "Ilość zaakceptowanych regulaminów: ": "",
        "Im konkretniejsze polecenie, tym lepszy efekt – podaj temat, długość i ton wypowiedzi.": "",
        "Imię": "",
        "Imię i nazwisko / nazwa autora": "",
        "Import": "",
        "Indeksowanie strony": "",
        "Informacja": "",
        "Informacja o ciasteczkach": "",
        "Informacje o komentarzu": "",
        "Informacje o zamówieniu": "",
        "inline": "",
        "INP": "",
        "Inspekcja": "",
        "Integracje": "",
        "Interakcja użytkownika (Komenatrze, Like)": "",
        "ISBN": "",
        "Jak przetworzyć zaznaczony fragment?": "",
        "jawne": "",
        "Jedno zdanie widoczne przy artykułach": "",
        "Jeśli pole jest puste to wstawiana automatycznie.": "",
        "Jest używana jako ekran logowania. Dla danego języka może istnieć tylko jedna.": "",
        "Jesteś w drugim dialogu: dodawanie powiązanego rekordu.": "",
        "Jesteś w drugim dialogu: edycja formularza.": "",
        "Jesteś w drugim dialogu: edycja wpisu.": "",
        "Język": "",
        "Język domyślny": "",
        "Język i ton": "",
        "Język regulaminu": "",
        "Języki": "",
        "JSON szablonu": "",
        "Kanał RSS:": "",
        "Karta": "",
        "Karta produktu": "",
        "Katalog": "",
        "Katalog główny": "",
        "Katalog i pozycja strony w strukturze witryny.": "",
        "Katalog linków": "",
        "Katalog został utworzony.": "",
        "Kategoria": "",
        "Kategoria linku": "",
        "Kategoria nadrzędna": "",
        "Kategoria subskrypcji": "",
        "Kategoria subskrypcji została dodana.": "",
        "Kategoria subskrypcji została usunięta.": "",
        "Kategoria subskrypcji została zaktualizowana.": "",
        "Kategoria urządzenia": "",
        "Kategoria zawierająca formularz dla tego wzoru.": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategorie": "",
        "Kategorię": "",
        "Kategorie linków": "",
        "Kategorię można opublikować tylko na jednej stronie.": "",
        "Kategorie subskrypcji": "",
        "Każdy komentarz pojawia się od razu.": "",
        "Kiedy": "",
        "Klienci": "",
        "Klient": "",
        "Kliknij stronę w drzewie po lewej, aby edytować jej ustawienia i metadane.": "",
        "Kliknij wybraną sekcję. Naciśnij Esc, aby anulować.": "",
        "Kliknij Zapisz u góry strony, aby opublikować zmianę.": "",
        "Klucz API wykorzystywany przez mapy Google w witrynie.": "",
        "Klucz OAuth używany razem z clientId do autoryzacji połączenia z PayU. Skopiuj client_secret z tego samego punktu POS.": "",
        "Klucz zgody Ipresso": "",
        "Kobieta": "",
        "Kod / miasto": "",
        "Kod bannera (tutaj wklej kod HTML i JS)": "",
        "Kod Bing Webmaster": "",
        "Kod Google Webmaster": "",
        "Kod GTM": "",
        "Kod HTML": "",
        "Kod weryfikacji witryny w Bing Webmaster Tools, bez całego znacznika HTML.": "",
        "Kod weryfikacji witryny w Google Search Console, bez całego znacznika HTML.": "",
        "kolejność": "",
        "Kolejność odpowiedzi": "",
        "Kolejność opinii": "",
        "Kolejność pytań i odpowiedzi": "",
        "Kolejność pytań zmienisz przeciąganiem lub strzałkami": "",
        "Kolejność sekcji": "",
        "Kolejność zmienisz przeciąganiem": "",
        "Kolejność zmienisz przeciąganiem lub strzałkami": "",
        "Kolor": "",
        "Kolor tekstu": "",
        "Kolor tekstu komunikatu.": "",
        "Kolor tła": "",
        "Kolor tła komunikatu.": "",
        "Kolumna {index}": "",
        "Kolumna {index} (%)": "",
        "Kolumna {number}": "",
        "Kolumny": "",
        "Komentarz": "",
        "Komentarz do wyłączenia ceny": "",
        "Komentarze": "",
        "Komentarze dłuższe nie zostaną zapisane.": "",
        "Komentarze gości trafiają do moderacji.": "",
        "Komentarze włączone": "",
        "Komentarze zawierające te słowa będą blokowane lub moderowane.": "",
        "Komputer": "",
        "Komunikat mailowy": "",
        "Konfiguracja": "",
        "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja shortcode": "",
        "Konfiguracja szablonu": "",
        "Konfiguracja widgetów jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja widgetu została zapisana.": "",
        "Konfiguruj stronę": "",
        "Konflikt edycji": "",
        "Kontener": "",
        "Konto": "",
        "Konto jest aktywne od razu po rejestracji.": "",
        "Konto publiczne": "",
        "Kontynent": "",
        "kopia": "",
        "Kopiuj": "",
        "Kopiuj adres": "",
        "Kopiuj do witryny": "",
        "Kopiuj link": "",
        "Kopiuj path": "",
        "Kopiuj sekcję do aranżacji": "",
        "Kopiuj widget": "",
        "Kopiuj widżet do witryny": "",
        "Kopiuj zmienną": "",
        "Korzysta wyłącznie z ustawień z zakładki Podstawowe.": "",
        "Koszyk": "",
        "Kraj": "",
        "Kreator stron": "",
        "Krótki identyfikator wzoru używany w systemie.": "",
        "Krótki opis": "",
        "Krótki opis widoczny na listingu linków": "",
        "Krótki tytuł": "",
        "Krótkie wprowadzenie przed główną treścią artykułu.": "",
        "krytyczne": "",
        "Krytyczne": "",
        "Książka": "",
        "Kto może korzystać z systemu komentarzy.": "",
        "Kurier": "",
        "Ładowanie edytora...": "",
        "Ładowanie elementów...": "",
        "Ładowanie podglądu...": "",
        "Ładowanie pól...": "",
        "Ładowanie treści...": "",
        "Ładowanie zgłoszeń…": "",
        "Ładuję opublikowaną wersję...": "",
        "Ładuję wersję roboczą...": "",
        "LCP": "",
        "Liczba": "",
        "Liczba ankiet": "",
        "Liczba artykułów": "",
        "Liczba kolumn": "",
        "Liczba kolumn w wierszu": "",
        "Liczba opinii: {count}. Kolejność zmienisz przeciąganiem lub strzałkami.": "",
        "Liczba ponowień płatności": "",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "",
        "Liczba stron głównego poziomu: {count}": "",
        "Liczba widżetów: {count}": "",
        "Liczba wyników": "",
        "Liczba wyświetlanych najnowszych elementów": "",
        "Liczba wyświetlanych slajdów": "",
        "Liczba wyświetleń": "",
        "Liczba zamówień": "",
        "Liczba znaków:": "",
        "Like do komentarzy mogą dodawać tylko zalogowani użytkownicy": "",
        "Limit zgłoszeń": "",
        "Limity": "",
        "Limity treści": "",
        "Linia ciągła": "",
        "Linia falująca": "",
        "Linia kreskowana": "",
        "Linia kropkowana": "",
        "Link": "",
        "Link do strony": "",
        "Link do widgetu skopiowany do schowka.": "",
        "Link do YouTube, Vimeo lub pliku mp4.": "",
        "Link może prowadzić do pliku z repozytorium albo do zewnętrznego serwisu": "",
        "Link obszaru": "",
        "Link prowadzi do pliku z repozytorium.": "",
        "Link prowadzi do zewnętrznego adresu.": "",
        "Link wewnętrzny": "",
        "Link wewnętrzny został dodany.": "",
        "Link wewnętrzny został usunięty.": "",
        "Link wewnętrzny został zaktualizowany.": "",
        "Link wygasł": "",
        "Link z serwisu": "",
        "Link zewnętrzny": "",
        "Link został dodany.": "",
        "Link został usunięty.": "",
        "Link został zaktualizowany.": "",
        "Linki wewnętrzne": "",
        "Linki wewnętrzne zostały pomyślnie połączone.": "",
        "Lista": "",
        "Lista artykułów": "",
        "Lista banerów": "",
        "Lista komentarzy": "",
        "Lista linków": "",
        "Lista publikacji": "",
        "Lista regulaminów": "",
        "Lista wyświetlana użytkownikowi przy zgłaszaniu.": "",
        "Live Design": "",
        "Live design (beta)": "",
        "llms.txt to rozwiązanie eksperymentalne": "",
        "Logo": "",
        "Logo używane w wiadomościach tej witryny. Jeśli nie wybierzesz pliku, zostanie użyte domyślne logo systemu.": "",
        "Logowanie": "",
        "Lp.": "",
        "Maksymalna ilość stron": "",
        "Maksymalna liczba najnowszych elementów pokazywanych na liście.": "",
        "Maksymalna liczba pozycji w kanale": "",
        "Maksymalna liczba znaków dla niezalogowanych": "",
        "Maksymalna liczba znaków dla zalogowanych": "",
        "Maksymalna szerokość strony to 1410": "",
        "Maksymalna wysokość strony to 1080": "",
        "Mapowanie pól modułów Studio (JSON)": "",
        "Marketing": "",
        "Masz niezapisane zmiany. Przejść bez zapisywania?": "",
        "Materiał wideo dołączony do wpisu": "",
        "Menu widgetu": "",
        "Metadane": "",
        "Metryka": "",
        "Mężczyzna": "",
        "Miasto": "",
        "Miejsce ankiety": "",
        "Miejsce artykułu w strukturze serwisu": "",
        "Miejsce otwarcia odnośnika (atrybut target), np. _blank dla nowej karty.": "",
        "Miejsce powiązanych artykułów": "",
        "Miesiące": "",
        "Miniatura wyświetlana przed odtworzeniem": "",
        "Minimalna szerokość strony to 370": "",
        "Minimalna wysokość strony to 500": "",
        "Mobile": "",
        "Moduł": "",
        "Moduł dynamiczny": "",
        "Moduł konfigurowalny": "",
        "Moduł nie wskazuje formularza dla sekcji tego widgetu.": "",
        "Moduł Studio zawierający formularz do wyświetlenia.": "",
        "Moduły": "",
        "Moduły wyszukiwarki": "",
        "Możesz zacząć od:": "",
        "Można ich używać we wszystkich polach tekstowych.": "",
        "Multimedia": "",
        "Multimedia premium": "",
        "Multimedia przypisane do artykułu": "",
        "Na ile dni po zakończeniu subskrypcji wysłać powiadomienie.": "",
        "Na ile dni przed końcem subskrypcji wysłać przypomnienie.": "",
        "Nabywca": "",
        "Naciśnij enter aby usunąć": "",
        "Naciśnij enter aby wybrać": "",
        "Nadaj banerowi nazwę, wybierz grupę i określ adres docelowy.": "",
        "Nadaj sekcji czytelną nazwę używaną podczas edycji aranżacji.": "",
        "Nadpisz": "",
        "Nagłówek widgetu widoczny dla odwiedzających stronę.": "",
        "Najczęstszy wybór. Wyświetla dane z wybranego modułu, np. Aktualności, Kontakt lub Reklamacje. Wymaga modułu i aranżacji.": "",
        "Najedź na widget albo pole w podglądzie.": "",
        "Najlepiej wybrać logo w formacie SVG — pozostaje ostre w każdym rozmiarze i dobrze wygląda na ekranach o wysokiej rozdzielczości.": "",
        "Najniższa cena z 30 dni przed obniżką": "",
        "Najniższy": "",
        "Najnowsza wersja": "",
        "Najpierw dodaj stronę do gazetki.": "",
        "Najpierw wybierz typ aranżacji": "",
        "Najpierw zapisz aranżację.": "",
        "Najpopularniejsze strony": "",
        "Najwięcej czasu spędzone na stronach": "",
        "Najwyższy": "",
        "Napisz krótki lead na podstawie fragmentu": "",
        "Napisz wstęp do artykułu o wdrożeniu nowego portalu": "",
        "Narzędzia": "",
        "Narzędzia podglądu": "",
        "Następne pole": "",
        "Nazwa": "",
        "Nazwa adresu": "",
        "Nazwa aktywnej strony": "",
        "Nazwa aranżacji": "",
        "Nazwa autora": "",
        "Nazwa czołówki": "",
        "Nazwa etapu": "",
        "Nazwa etykiety": "",
        "Nazwa grupy": "",
        "Nazwa i adres strony w witrynie.": "",
        "Nazwa katalogu": "",
        "Nazwa kategorii": "",
        "Nazwa Kategorii": "",
        "Nazwa linku": "",
        "Nazwa nowej kategorii": "",
        "Nazwa obiektu": "",
        "Nazwa pakietu": "",
        "Nazwa płyty": "",
        "Nazwa rotatora": "",
        "Nazwa sekcji": "",
        "Nazwa shortcode": "",
        "Nazwa slajdera": "",
        "Nazwa slajdu": "",
        "Nazwa strony": "",
        "Nazwa szablonu": "",
        "Nazwa typu aranżacji": "",
        "Nazwa ułatwia rozpoznanie aranżacji przy przypisywaniu jej do strony.": "",
        "Nazwa w panelu": "",
        "Nazwa wewnętrzna": "",
        "Nazwa widoczna na liście wzorów. Powinna jasno wskazywać przeznaczenie shortcode.": "",
        "Nazwa widoczna na stronie i w panelu oraz miejsce w drzewie": "",
        "Nazwa widoczna wyłącznie w panelu administracyjnym.": "",
        "Nazwa widżetu": "",
        "Nazwa witryny": "",
        "Nazwa wyświetlana": "",
        "Nazwa zduplikowanej aranżacji": "",
        "Nazwa, domena i szablon graficzny witryny.": "",
        "Nazwa, opis i przypisanie linku": "",
        "Nazwa, oznaczenie i ikona shortcode.": "",
        "Nazwisko": "",
        "Neutralny": "",
        "Nic nie publikuje się bez zatwierdzenia.": "",
        "Nie": "",
        "Nie dodano żadnego autora.": "",
        "Nie ma jeszcze żadnych rekordów": "",
        "Nie ma własnej treści. Kieruje do wybranej strony tej samej witryny; można dodać parametry URL.": "",
        "Nie ma własnej treści. Kieruje pod podany pełny adres URL i może otworzyć go w nowym oknie.": "",
        "Nie można już edytować tego linku wewnętrznego, ponieważ jest on aktualnie używany.": "",
        "Nie można usunąć zaznaczonych autorów, ponieważ co najmniej jeden z nich jest przypisany do artykułów.": "",
        "Nie można uzupełnić danych linku. Otwórz okno linku ponownie.": "",
        "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "",
        "Nie pokazuj linku do archiwum strony (NoArchive)": "",
        "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "",
        "Nie pomocna": "",
        "Nie posiadasz uprawnień do edycji tego artykułu.": "",
        "Nie udało się dodać widgetu do aranżacji.": "",
        "Nie udało się odświeżyć listy zestawów. Spróbuj ponownie.": "",
        "Nie udało się otworzyć dodawania powiązanego rekordu.": "",
        "Nie udało się otworzyć edycji formularza.": "",
        "Nie udało się otworzyć edycji powiązanego rekordu.": "",
        "Nie udało się otworzyć formularza": "",
        "Nie udało się otworzyć podglądu aranżacji.": "",
        "Nie udało się oznaczyć zamówienia jako opłacone.": "",
        "Nie udało się pobrać adresu strony.": "",
        "Nie udało się pobrać aranżacji.": "",
        "Nie udało się pobrać dostępnych aranżacji.": "",
        "Nie udało się pobrać listy aranżacji": "",
        "Nie udało się pobrać listy etykiet": "",
        "Nie udało się pobrać listy kategorii": "",
        "Nie udało się pobrać listy modułów": "",
        "Nie udało się pobrać listy regulaminów": "",
        "Nie udało się pobrać listy stron": "",
        "Nie udało się pobrać listy witryn.": "",
        "Nie udało się pobrać pakietu.": "",
        "Nie udało się pobrać pełnej listy zestawów.": "",
        "Nie udało się pobrać powiązanych wpisów dla tego widgetu.": "",
        "Nie udało się pobrać treści.": "",
        "Nie udało się pobrać ustawień wpisu dla tego widgetu.": "",
        "Nie udało się pobrać witryn.": "",
        "Nie udało się pobrać wybranych treści.": "",
        "Nie udało się pobrać wyników ankiety. Spróbuj ponownie.": "",
        "Nie udało się rozpoznać endpointu schemy formularza.": "",
        "Nie udało się skopiować adresu.": "",
        "Nie udało się skopiować do schowka.": "",
        "Nie udało się skopiować widgetu.": "",
        "Nie udało się ustalić powiązanego rekordu.": "",
        "Nie udało się ustalić źródła powiązanego rekordu.": "",
        "Nie udało się ustalić źródła powiązanych rekordów.": "",
        "Nie udało się ustawić aranżacji domyślnej": "",
        "Nie udało się wczytać danych klienta.": "",
        "Nie udało się wczytać grupy banerów.": "",
        "Nie udało się wczytać kanałów RSS": "",
        "Nie udało się wczytać klientów.": "",
        "Nie udało się wczytać komentarzy.": "",
        "Nie udało się wczytać przekierowań.": "",
        "Nie udało się wczytać sitemap. Spróbuj ponownie.": "",
        "Nie udało się wczytać szablonów.": "",
        "Nie udało się wczytać ustawień": "",
        "Nie udało się wczytać ustawień komentarzy.": "",
        "Nie udało się wczytać ustawień RSS": "",
        "Nie udało się wczytać ustawień RSS. Spróbuj ponownie.": "",
        "Nie udało się wczytać ustawień sitemap.": "",
        "Nie udało się wczytać ustawień witryny.": "",
        "Nie udało się wczytać widgetu.": "",
        "Nie udało się wczytać witryn.": "",
        "Nie udało się wczytać wszystkich danych kategorii.": "",
        "Nie udało się wczytać wzorów shortcode.": "",
        "Nie udało się wczytać wzoru shortcode.": "",
        "Nie udało się wczytać zamówień.": "",
        "Nie udało się wczytać zamówienia.": "",
        "Nie udało się wczytać zgłoszeń": "",
        "Nie udało się wczytać zgłoszeń. Spróbuj ponownie.": "",
        "Nie udało się wczytać zgód": "",
        "Nie udało się wyeksportować przekierowań.": "",
        "Nie udało się wygenerować stron gazetki.": "",
        "Nie udało się zaimportować przekierowań.": "",
        "Nie udało się zaktualizować wybranych aranżacji.": "",
        "Nie udało się załadować podglądu.": "",
        "Nie udało się zapisać grupy banerów.": "",
        "Nie udało się zapisać ustawień. Sprawdź wartości i spróbuj ponownie.": "",
        "Nie udało się zapisać zmiany.": "",
        "Nie udało się zduplikować widgetu.": "",
        "Nie udało się zlecić generowania sitemap.": "",
        "Nie wybrano authora.": "",
        "Nie wybrano autora.": "",
        "Nie wybrano jeszcze żadnego regulaminu. Wyszukaj regulamin powyżej i dodaj go do zestawu.": "",
        "Nie wybrano strony": "",
        "Nie wybrano żadnej kategorii": "",
        "Nie wybrano żadnej strony.": "",
        "Nie zdefiniowano żadnych sekcji.": "",
        "Nie znaleziono edytowalnych pól w aktualnym podglądzie.": "",
        "Nie znaleziono opublikowanej aranżacji.": "",
        "Nie znaleziono problemów.": "",
        "Nie znaleziono widocznego elementu tego pola w aktualnym DOM podglądu.": "",
        "Nie znaleziono żadnych folderów.": "",
        "Nie związana": "",
        "Nieaktywna": "",
        "Nieaktywne": "",
        "Nieaktywny": "",
        "Niedostępny widżet może być wyłączony dla witryny lub już użyty jako unikalny element.": "",
        "Niedozwolone słowa": "",
        "Niedziela": "",
        "Nieformalny": "",
        "niejednoznaczne": "",
        "Niejednoznaczne": "",
        "Niemiecki": "",
        "Nieobsługiwane pole edycji inline.": "",
        "Nieopłacone": "",
        "Niepotwierdzona": "",
        "Niestandardowy adres": "",
        "Niestandardowy adres strony": "",
        "Niestandardowy nagłówek": "",
        "Nieudana próba doręczenia": "",
        "Niezapisane zmiany:": "",
        "Nieznany status": "",
        "Nigdy": "",
        "NIP": "",
        "Niski": "",
        "Niżej": "",
        "Nofollow": "",
        "Nowa": "",
        "Nowa aktualność": "",
        "Nowa aranżacja": "",
        "Nowa cena brutto": "",
        "Nowa cena do": "",
        "Nowa cena od": "",
        "Nowa cena zacznie obowiązywać w podanym okresie.": "",
        "Nowa kategoria": "",
        "Nowe pytanie": "",
        "Nowy artykuł": "",
        "Nowy autor": "",
        "Nowy widżet": "",
        "np. _blank": "",
        "np. 7": "",
        "np. Banner e-commerce": "",
        "np. Czołówka Technologia": "",
        "np. E-commerce": "",
        "np. pim": "",
        "np. pl-PL": "",
        "np. poradnik": "",
        "np. Poradniki": "",
        "np. Spam": "",
        "np. Trwają prace serwisowe": "",
        "np. wyrażenie": "",
        "np. Zenon Mącugowski": "",
        "Numer": "",
        "Numer aktywnej strony": "",
        "Numer telefonu": "",
        "Obraz": "",
        "Obrazy bez wymiarów": "",
        "Obrazy: automatycznie": "",
        "Obrazy: zawsze leniwie": "",
        "Obrazy: zawsze natychmiast": "",
        "Obsługiwane są wyłącznie linki wewnętrzne": "",
        "Obszary aktywne": "",
        "Ochrona przed spamem": "",
        "Oczekujące": "",
        "Oczekujący na akceptację": "",
        "Oczekuje na akceptację": "",
        "Oczekuje na płatność": "",
        "Oczekuje na potwierdzenie": "",
        "Oczekuje na weryfikację": "",
        "Oczekuje na wysyłkę": "",
        "Oczekuje na zatwierdzenie": "",
        "Od 1 do 50 najnowszych pozycji w każdym kanale RSS. Ustawienie dotyczy wszystkich witryn.": "",
        "Od poziomu": "",
        "Odczyt tylko po zalogowaniu": "",
        "Odebrane w punkcie": "",
        "Odepnij": "",
        "Odepnij od widżetu": "",
        "Odnośnik": "",
        "Odnośnik do informacji o plikach cookies.": "",
        "Odnośnik do informacji o przetwarzaniu danych osobowych.": "",
        "Odnośnik do innej strony w serwisie": "",
        "Odnośnik do strony w serwisie": "",
        "Odnośnik do zewnętrznego adresu": "",
        "Odnośnik URL": "",
        "Odnośniki": "",
        "Odpięto dev details": "",
        "Odpowiedź": "",
        "Odpowiedź {number}": "",
        "Odpowiedzi": "",
        "Odrzuć": "",
        "Odrzuć zmiany": "",
        "Odrzucone": "",
        "Odrzucone zgody": "",
        "Odrzucony po zgłoszeniach": "",
        "Odśwież": "",
        "Odśwież podgląd": "",
        "Odśwież wybór witryny i spróbuj ponownie.": "",
        "Odświeżam podgląd formularza...": "",
        "Odświeżam podgląd po dodaniu treści...": "",
        "Odświeżam podgląd...": "",
        "Odświeżono": "",
        "Odświeżono schemę formularza": "",
        "Odznacz wszystkie": "",
        "Ogólny": "",
        "Ograniczenia długości komentarzy.": "",
        "Okładka": "",
        "Okładka do wideo premium": "",
        "Okładka oraz pliki PDF źródłowy i do pobrania.": "",
        "Okres, w którym temat jest widoczny.": "",
        "Określ dostępność witryny oraz sposób dostępu do jej treści.": "",
        "Określ zasady odkrywania treści i ich użycia przez dostawców AI.": "",
        "Określ, jak aktywowane są konta zakładane przez rejestrację.": "",
        "Określ, kto może wyświetlić stronę.": "",
        "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "",
        "Określa, od kiedy komunikat ma być widoczny na stronie.": "",
        "Opcje linku": "",
        "Opcje modułu przypisanego do tej strony.": "",
        "Opcjonalne zdjęcie używane jako tło treści.": "",
        "Open Graph": "",
        "Operator płatności": "",
        "Opinia": "",
        "Opinia autora": "",
        "Opinie": "",
        "Opis": "",
        "Opis przerwy technicznej": "",
        "Opis sekcji": "",
        "Opis witryny": "",
        "Opis wyświetlany pod odtwarzaczem": "",
        "Opisz, co mam napisać": "",
        "Opłacone": "",
        "Opublikował": "",
        "Opublikowana": "",
        "Opublikowane": "",
        "Opublikowane języki": "",
        "Opublikowane wersje językowe.": "",
        "Opublikowany na stronach": "",
        "Opublikuj": "",
        "Opublikuj autora": "",
        "Origin formularza": "",
        "Oś czasu": "",
        "Osobne warianty dla różnych szerokości ekranu.": "",
        "Osoby podpisane pod artykułem": "",
        "Ostatni miesiąc": "",
        "Ostatni rok": "",
        "Ostatni tydzień": "",
        "Ostatnia aktualizacja:": "",
        "Ostrzeżenia": "",
        "ostrzeżenie": "",
        "Otwiera się pod głównym adresem witryny. Dla danego języka może istnieć tylko jedna.": "",
        "Otwieraj w nowym oknie": "",
        "Otwórz edytor": "",
        "Otwórz podgląd llms.txt": "",
        "Otwórz podgląd llms.txt i sprawdź opublikowaną zawartość.": "",
        "Otwórz podgląd robots.txt": "",
        "Otwórz stronę w nowym oknie": "",
        "Otwórz w nowej karcie": "",
        "Otworzono dodawanie wpisu": "",
        "Otworzono edytor wpisu": "",
        "Otworzono formularz": "",
        "Oznacz jako opłacone": "",
        "Oznacza artykuł jako materiał sponsorowany.": "",
        "Oznacza artykuł jako opinię autora.": "",
        "Oznacza tę witrynę jako główną w systemie.": "",
        "Oznacza treść jako dostępną w ramach premium.": "",
        "Pakiet": "",
        "Pakiet aktywny": "",
        "Pakiet autoodnawialny": "",
        "Pakiet debugowy skopiowany do schowka.": "",
        "Pakiety": "",
        "Parametry email": "",
        "PayU": "",
        "Pełna strona": "",
        "Pełna szerokość": "",
        "Pełny adres aktywnej strony": "",
        "Pełny adres wraz z \"http(s)://\".": "",
        "Piątek": "",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "",
        "Pierwsze powiadomienie": "",
        "Pierwsze zdjęcie jest okładką galerii. Kolejność zmienisz przeciąganiem.": "",
        "Pierwsze zdjęcie w galerii jest zdjęciem głównym": "",
        "Piosenka": "",
        "Pisać mogą tylko zalogowani użytkownicy": "",
        "Płatność": "",
        "Płatności cykliczne": "",
        "Płeć": "",
        "Plik": "",
        "Plik gazetki (PDF)": "",
        "Plik gazetki do pobrania (PDF)": "",
        "Plik graficzny": "",
        "Plik llms.txt": "",
        "Plik wideo": "",
        "Plik z repozytorium albo adres URL": "",
        "Pliki do pobrania dostępne w ramach treści premium.": "",
        "Pliki do pobrania pod wpisem": "",
        "Pliki dokumentu": "",
        "Pliki dostępne do pobrania przy artykule.": "",
        "Pliki gazetki": "",
        "Płyta z muzyką": "",
        "Po aktywacji odwiedzający zobaczą komunikat o przerwie technicznej. Użytkownicy z uprawnieniami administratora nadal mają dostęp do witryny.": "",
        "Po otwarciu listy widzisz pierwsze wyniki. Wpisz początek wartości z pola identyfikującego, aby zawęzić listę.": "",
        "Po potwierdzeniu e-maila konto wymaga zatwierdzenia przez administratora.": "",
        "Po przekroczeniu komentarz trafia do moderacji.": "",
        "Po tym czasie nieopłacone zamówienie wygasa.": "",
        "Po zakończeniu subskrypcji": "",
        "Po zapisaniu artykułu w wybranej wersji językowej, nie będzie możliwości jej zmiany.": "",
        "Po zapisaniu nie można jej zmienić.": "",
        "Po zapisie rekord będzie dostępny w edytorze powiązań Live Design.": "",
        "Pobieranie płatności dla subskrypcji autoodnawialnych.": "",
        "Pobierz wyniki": "",
        "Poczta": "",
        "Pod spodem nadal masz otwarty podgląd aranżacji.": "",
        "Podaj adres docelowy i sposób otwierania odnośnika.": "",
        "Podaj adres url...": "",
        "Podaj identyfikatory administratorów Facebooka, oddzielając je przecinkami.": "",
        "Podaj liczbę całkowitą od 1 do 50.": "",
        "Podaj pełny adres wraz z protokołem.": "",
        "Podaj poprawny adres e-mail.": "",
        "Podaj temat, długość i ton tekstu…": "",
        "Podążanie za linkami": "",
        "Podgląd": "",
        "Podgląd aranżacji": "",
        "Podgląd artykułu": "",
        "Podgląd JSON": "",
        "Podgląd Open Graph": "",
        "Podgląd opublikowanej wersji aranżacji.": "",
        "Podgląd otwiera aktualnie opublikowany plik. Przy wyłączonej publikacji plik jest niedostępny. Tytuły i opisy zmienisz w treściach lub metadanych CMS — plik powstaje przy otwieraniu i nie wymaga ponownego generowania.": "",
        "Podgląd pokazuje zapisane reguły. Zapisz witrynę, aby sprawdzić wprowadzone zmiany.": "",
        "Podgląd strony": "",
        "Podgląd w mediach społecznościowych.": "",
        "Podgląd wartości pola": "",
        "Podgląd wersji roboczej aranżacji.": "",
        "Podgląd został odświeżony, ale schema formularza nie zmieniła się. Sprawdź, czy zapisana wersja jest tą, którą zwraca endpoint schemy.": "",
        "Podłącz linki": "",
        "Podłącz linki wewnętrzne": "",
        "Podpis schemy": "",
        "Podstawowe": "",
        "Podstawowe informacje": "",
        "Podwójna linia ciągła": "",
        "Pojedyncza publikacja": "",
        "Pojedyńcza, prosta, ciągła linia": "",
        "Pojedynczy artykuł (strona opisowa)": "",
        "Pokaż etykietę": "",
        "Pokaż niedostępne widgety": "",
        "Pokaż skróty": "",
        "Pokaż w podglądzie": "",
        "Pokaż więcej": "",
        "Pokazuj niedostępne widżety": "",
        "Pokazuje samą treść artykułu, bez dodatkowej oprawy.": "",
        "Pola": "",
        "Pola wypełniane podczas wstawiania shortcode.": "",
        "Pole \"%0\" jest wymagane.": "",
        "Pole \"Ilość dni przed\" jest wymagane.": "",
        "Pole \"Język\" jest wymagane.": "",
        "Pole \"Metryka\" jest wymagane.": "",
        "Pole \"Nazwa\" jest wymagane.": "",
        "Pole \"Sortuj według\" jest wymagane.": "",
        "Pole \"Witryna\" jest wymagane.": "",
        "Pole \"Wymiar\" jest wymagane.": "",
        "Pole identyfikujące dokument": "",
        "Pole jest puste.": "",
        "Pole jest widoczne, ale kliknięcie prowadzi do edytora formularzowego.": "",
        "Pole jest widoczne, ale nie ma osobnego klikalnego targetu inline. Otworzy się edytor formularzowy.": "",
        "Pole można edytować bezpośrednio w podglądzie.": "",
        "Pole nie ma widocznego elementu w aktualnym podglądzie.": "",
        "Pole pasuje do kilku elementów w podglądzie. Wybierz target ręcznie w Live Design.": "",
        "Polski": "",
        "Polubienia": "",
        "Polubienia tylko po zalogowaniu": "",
        "Pomoc": "",
        "Pomocna": "",
        "Ponawianie...": "",
        "Poniedziałek": "",
        "Ponów": "",
        "Ponów ostatnią cofniętą zmianę inline": "",
        "Ponowiono operację na widgetu": "",
        "Popraw błędy ortograficzne i interpunkcyjne": "",
        "Popraw literówki, zachowaj oryginalny styl": "",
        "Popraw merytorycznie": "",
        "Popraw nieścisłości i uprość sformułowania": "",
        "Popraw odmianę i zgodność form gramatycznych": "",
        "Poprzedni okres": "",
        "Poprzednie pole": "",
        "Popularność": "",
        "Porównanie wersji": "",
        "Porównano pola formularza": "",
        "Potwierdź": "",
        "Potwierdź akceptację": "",
        "Potwierdź oznaczenie zamówienia jako opłacone.": "",
        "Potwierdź przywrócenie wersji roboczej": "",
        "Potwierdź usunięcie": "",
        "Potwierdź usunięcie regulaminu {name}": "",
        "Potwierdź usunięcie slajdu {number}": "",
        "Potwierdź usunięcie zestawu {name}": "",
        "Potwierdzenie mailowe": "",
        "Potwierdzenie mailowe i akceptacja administratora": "",
        "Potwierdzenie przywrócenia": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie wysłania": "",
        "Potwierdzenie zatwierdzenia": "",
        "Potwierdzenie zmiany statusu": "",
        "Potwierdzone": "",
        "Powiadomienia": "",
        "Powiązana galeria": "",
        "Powiązana kategoria": "",
        "Powiązane artykuły": "",
        "Powiązane galerie": "",
        "Powiązane kategorie": "",
        "Powiązane opinie": "",
        "Powiązane rekordy": "",
        "Powiązane wideo": "",
        "Powiązanie": "",
        "Powiązany artykuł": "",
        "Powiązany autor": "",
        "Powiązany obiekt": "",
        "Powód": "",
        "Powody zgłoszeń": "",
        "Powrót": "",
        "poza DOM": "",
        "Poza DOM": "",
        "Pozostałe ustawienia": "",
        "Pozostaw puste, aby nie ustawiać daty końcowej.": "",
        "Pozostaw puste, jeśli komunikat nie ma daty końcowej.": "",
        "Pozwala dostawcom AI pobierać treści do uczenia modeli i uzupełniania odpowiedzi. Reguła jest zapisywana w robots.txt, niezależnie od publikacji llms.txt.": "",
        "Pozwala robotom wyszukiwarek AI przeglądać treści witryny. Reguła trafia automatycznie do robots.txt po zapisaniu witryny.": "",
        "Pozwala użytkownikom przekazywać komentarze do moderacji.": "",
        "Pozycje z lewej": "",
        "Pozycje z prawej": "",
        "Premiera": "",
        "Premium": "",
        "Premium otwarty": "",
        "Prezentacja": "",
        "Priorytet": "",
        "Priorytet (priority)": "",
        "Priorytet publikacji": "",
        "Produkcyjne": "",
        "Profil użytkownika": "",
        "Projekt aranżacji": "",
        "Proporcja {ratio} : 1": "",
        "Propozycja": "",
        "Prosty": "",
        "Protokół OAuth - clientId": "",
        "Protokół OAuth - clientSecret": "",
        "Przechowywanie danych witryny w pamięci podręcznej.": "",
        "Przeciągnij autorów, aby ustalić kolejność ich wyświetlania na stronie.": "",
        "Przeciągnij kategorie, aby ustalić kolejność ich wyświetlania na stronie.": "",
        "Przeciągnij pakiety, aby ustalić kolejność ich wyświetlania.": "",
        "Przeciągnij tutaj widget z biblioteki.": "",
        "Przeciągnij widżet do sekcji lub kliknij, aby wybrać miejsce i skonfigurować jego treść.": "",
        "Przeciągnij, aby zmienić kolejność": "",
        "Przed zakończeniem subskrypcji": "",
        "Przeglądarka": "",
        "Przejdź": "",
        "Przejdź do aranżacji": "",
        "Przejdź do poprzedniego lub następnego pola inline": "",
        "Przejść do edycji menu bez zapisywania zmian?": "",
        "Przekierowania": "",
        "Przekierowanie aktywne": "",
        "Przekierowanie zostało usunięte.": "",
        "Przekierowanie zostało zapisane.": "",
        "przekroczony": "",
        "Przełącz": "",
        "Przełączenie na tryb statyczny usunie zdefiniowane sekcje dynamiczne dla tego typu aranżacji.": "",
        "Przenieś artykuł": "",
        "Przenieś do sekcji": "",
        "Przenieś kategorię niżej": "",
        "Przenieś kategorię wyżej": "",
        "Przenieś niżej": "",
        "Przenieś odpowiedź {number}": "",
        "Przenieś opinię {number}": "",
        "Przenieś plik": "",
        "Przenieś później": "",
        "Przenieś pytanie {number}": "",
        "Przenieś pytanie niżej": "",
        "Przenieś pytanie wyżej": "",
        "Przenieś sekcję {name}": "",
        "Przenieś slajd {number} w dół": "",
        "Przenieś slajd {number} w górę": "",
        "Przenieś treść modułu": "",
        "Przenieś wcześniej": "",
        "Przenieś widżet {name}": "",
        "Przenieś wyżej": "",
        "Przeniesiono widget": "",
        "Przepisz zaznaczony fragment i podziel go na akapity": "",
        "Przepisz zaznaczony fragment i skróć go o połowę": "",
        "Przepisz zaznaczony fragment, pozostawiając dane i liczby": "",
        "Przepisz zaznaczony fragment, zachowując jego sens": "",
        "Przeredaguj zaznaczony fragment na bardziej formalny": "",
        "Przerwa techniczna": "",
        "Przesuń do góry": "",
        "Przesuń niżej": "",
        "Przesuń w dół": "",
        "Przesuń wyżej": "",
        "Przetłumacz i dostosuj tekst do lokalnego czytelnika": "",
        "Przetłumacz zaznaczony fragment w stylu formalnym": "",
        "Przetłumacz zaznaczony fragment, pozostawiając nazwy własne bez zmian": "",
        "Przetłumacz zaznaczony fragment, zachowując ton wypowiedzi": "",
        "Przygotowuję formularz edycji.": "",
        "Przypięto dev details": "",
        "Przypisz pola tytułu, opisu i daty do klucza modułu Studio. Puste pole pozostawia domyślne mapowanie.": "",
        "Przypnij": "",
        "Przywróć": "",
        "Przywróć kolejność domyślną": "",
        "Przywróć wszystkie": "",
        "Pseudonim": "",
        "Publiczne ID": "",
        "Publikacja": "",
        "Publikacja dokumentu": "",
        "Publikacja galerii przez użytkownika": "",
        "Publikacja nie gwarantuje użycia treści przez konkretnego dostawcę AI.": "",
        "Publikacja priorytetowa": "",
        "Publikacja strony i jej obecność w menu.": "",
        "Publikacja wideo przez użytkownika": "",
        "Publikacja zarchiwizowana": "",
        "Publikacja została dodana.": "",
        "Publikacja została usunięta.": "",
        "Publikuj": "",
        "Publikuj do": "",
        "Publikuj llms.txt": "",
        "Publikuj na stronie": "",
        "Publikuj na wybranej stronie": "",
        "Publikuj od": "",
        "Publikuj slajd {number} do": "",
        "Publikuj slajd {number} od": "",
        "Publikuj slajder do": "",
        "Pusta sekcja": "",
        "puste": "",
        "Puste – bez daty końcowej.": "",
        "Puste = bez daty końcowej.": "",
        "Pusty układ — zacznij od własnej kompozycji.": "",
        "Pytania i odpowiedzi": "",
        "Pytanie": "",
        "razy": "",
        "Recaptcha": "",
        "Ręczna akceptacja wszystkich komentarzy": "",
        "Ręczny wybór zdjęć lub galerii": "",
        "Redakcja": "",
        "Redaktor został zaktualizowany.": "",
        "Region": "",
        "Regulamin wymagany": "",
        "Regulamin został dodany.": "",
        "Regulamin został zaktualizowany.": "",
        "Regulaminy": "",
        "Regulaminy z zapisaną datą odrzucenia.": "",
        "Regulaminy zaakceptowane przez użytkownika.": "",
        "Reguły wygaśnięcia i anulowania nieopłaconych zamówień.": "",
        "Rejestracja": "",
        "Rejestracja konta": "",
        "Repozytorium": "",
        "Repozytorium plików": "",
        "Reżyseria": "",
        "Robocza": "",
        "Roboty nie podążają za tym odnośnikiem.": "",
        "Rodzaj adresu kanonicznego": "",
        "Rodzaj pozycji menu": "",
        "Rodzaj strony": "",
        "Rodzaj źródła": "",
        "Rotator": "",
        "Rotator został dodany.": "",
        "Rotator został usunięty.": "",
        "Rotator został zaktualizowany.": "",
        "Rotatory opinii": "",
        "Rozbudowany": "",
        "Rozbuduj i podziel na dwa akapity": "",
        "Rozbuduj tekst": "",
        "Rozciąga artykuł na pełną szerokość strony.": "",
        "Rozpoczęcie pobrania płatności przed końcem subskrypcji": "",
        "Rozwiń akapit o korzyściach dla redakcji": "",
        "Rozwiń do": "",
        "Rozwiń fragment o dwa zdania, zachowując ton wypowiedzi": "",
        "Rozwiń panel podglądu": "",
        "RSS": "",
        "Scenariusz": "",
        "schema bez zmian": "",
        "Schema formularza bez zmian": "",
        "schema OK": "",
        "schema po refreshu": "",
        "Schema URL": "",
        "Ścieżka": "",
        "Ścieżka aktywnej strony": "",
        "Ścieżka nawigacyjna": "",
        "ścieżka strony CMS": "",
        "sek.": "",
        "Sekcja": "",
        "Sekcja %0": "",
        "Sekcja aranżacji": "",
        "Sekcja docelowa": "",
        "Sekcja komentarzy": "",
        "Sekcja modułu": "",
        "Sekcja pod artykułem": "",
        "Sekcja śródtekstowa": "",
        "Sekcja wybranego modułu używana przez widżet.": "",
        "Sekcje": "",
        "Sekcje szablonu": "",
        "Sekcje treści": "",
        "Sekcje użytkownika": "",
        "SEO": "",
        "Separator elementów w tytule": "",
        "Separator tytułu i generowanie mapy witryny.": "",
        "Serial telewizyjny": "",
        "Serie kresek lub fragmentów linii": "",
        "Serie kropek": "",
        "Serwis": "",
        "Shorcode nie istnieje. Usuń go z edytora.": "",
        "Shortcode": "",
        "Shortcode testowy": "",
        "ShortCode został dodany.": "",
        "Shortcode został usunięty": "",
        "ShortCode został zaktualizowany.": "",
        "Shortcodes": "",
        "Sitemap nie wskazuje formularza dla tej schemy.": "",
        "Sitemapy": "",
        "Skopiowano": "",
        "Skopiowano dev details": "",
        "Skopiowano JSON szablonu do schowka.": "",
        "Skopiowano link do widgetu": "",
        "Skopiowano pakiet debugowy": "",
        "Skrócony opis": "",
        "Skróty klawiszowe": "",
        "Skrypty statystyczne, np. Analytics lub Matomo. Są dodawane w górnej części <head> witryny.": "",
        "Skrypty targetujące, np. Google Tag Manager lub Pixel Facebook. Są dodawane w górnej części <body> witryny.": "",
        "Skrypty zewnętrzne": "",
        "Skup na tym bloku": "",
        "Skupiono widget": "",
        "Slajd {number}": "",
        "Slajder został dodany.": "",
        "Slajder został usunięty.": "",
        "Slajder został zaktualizowany.": "",
        "Slajdery": "",
        "słów": "",
        "Słowa kluczowe": "",
        "Słowa kluczowe opisujące artykuł": "",
        "Słowa oddzielone przecinkami.": "",
        "Słowo": "",
        "Słowo lub wyrażenie zamieniane na link.": "",
        "slug lub tytuł": "",
        "slug strony z listą": "",
        "slug tytułu": "",
        "slugifikowany pełny tytuł treści w języku sitemapy": "",
        "slugifikowany tytuł": "",
        "Sobota": "",
        "Sortowanie": "",
        "Sortowanie autorów": "",
        "Sortowanie kategorii": "",
        "Sortowanie pakietów": "",
        "Sortuj autorów": "",
        "Sortuj kategorie": "",
        "Sortuj pakiety": "",
        "Sortuj według": "",
        "Specjalne role w serwisie": "",
        "Sposób ładowania obrazów w tej sekcji": "",
        "Sposób ładowania obrazów w tej sekcji (dziedziczony przez aranżacje)": "",
        "Sposób publikacji nowych komentarzy.": "",
        "Sprawdź gramatykę": "",
        "Sprawdź nazwę kategorii.": "",
        "Sprawdź połączenie i spróbuj ponownie.": "",
        "Sprawdź poprawność faktów i nazw własnych": "",
        "Sprawdź, czy w treści nie ma powtórzeń": "",
        "Spróbuj pobrać listę ponownie.": "",
        "Spróbuj ponownie": "",
        "Środa": "",
        "Środowisko": "",
        "stały identyfikator": "",
        "Stara cena brutto": "",
        "Status": "",
        "Status aranżacji został zmieniony.": "",
        "Status artykułu": "",
        "Status baneru został zmieniony.": "",
        "Status dokumentu został zmieniony.": "",
        "Status galerii został zmieniony.": "",
        "Status komentarzy": "",
        "Status linku został zmieniony.": "",
        "Status przekierowania został zmieniony.": "",
        "Status regulaminu został zmieniony.": "",
        "Status wideo został zmieniony.": "",
        "Status zamówienia": "",
        "Statyczny": "",
        "Streść fragment w dwóch zdaniach": "",
        "Streść fragment w pięciu punktach": "",
        "Streść treść w pięciu punktach": "",
        "Streszczenie": "",
        "Strona": "",
        "Strona błędu 404": "",
        "Strona CMS": "",
        "Strona do publikacji": "",
        "Strona docelowa dla 'Czytaj więcej'": "",
        "Strona docelowa dla 'Kontakt z adminem'": "",
        "Strona docelowa dla 'Pliki cookies'": "",
        "Strona docelowa dla 'Polityka prywatności'": "",
        "Strona dostępna dla wszystkich": "",
        "Strona dostępna tylko dla zalogowanych użytkowników": "",
        "Strona głowna": "",
        "Strona główna": "",
        "Strona główna serwisu": "",
        "Strona kanoniczna": "",
        "Strona konta użytkownika powiązana z powiadomieniami.": "",
        "Strona korzystająca tylko z aranżacji": "",
        "Strona korzystająca z modułu": "",
        "Strona logowania użytkowników": "",
        "Strona nadrzędna": "",
        "Strona obsługująca logowanie i konto użytkownika.": "",
        "Strona opublikowana": "",
        "Strona ukryta w menu": "",
        "Strona utworzona w PageBuilderze": "",
        "Strona z modułu konto użytkownika": "",
        "Strona z modułu wyszukiwarki": "",
        "Strona została dodana.": "",
        "Strona została usunięta.": "",
        "Strona została zaktualizowana.": "",
        "Strona, na której użytkownik znajdzie kontakt do administratora.": "",
        "Strona, na której wyświetlane są wyniki wyszukiwania.": "",
        "Strona/kategoria nadrzędna": "",
        "Strony": "",
        "Strony gazetki": "",
        "Strony publikacji": "",
        "Strony z treścią": "",
        "Struktura menu": "",
        "Struktura serwisu": "",
        "Struktura stron": "",
        "Studio": "",
        "Studio obsługuje również pola formularza. Klucz szablonu ma postać „symbolModułu/symbolSekcji”.": "",
        "Styl tekstu": "",
        "Styl Tekstu": "",
        "Subskrypcja": "",
        "Subskrypcja aktywna": "",
        "Subskrypcje": "",
        "Subskrypcje klienta": "",
        "Suma": "",
        "Suma proporcji musi wynosić 100%. Pozostałe kolumny przejdą do kolejnego wiersza.": "",
        "Sygnatura widoczna na listingu.": "",
        "Symbol": "",
        "Symbol autora": "",
        "Symbol linku": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -.": "",
        "Symbol strony": "",
        "Symboliczne miejsce na treść modułu strony korzystającej z tego typu aranżacji.": "",
        "Synchronizuj": "",
        "System": "",
        "System operacyjny": "",
        "Szablon nie określa miejsca treści modułu.": "",
        "Szablon określa sekcje, w których możesz umieszczać widgety. Wybierz układ odpowiedni dla tej strony.": "",
        "Szablon określa układ wiadomości. W wysyłce używana jest jego opublikowana wersja.": "",
        "Szablon wiadomości": "",
        "Szablon został dodany.": "",
        "Szablon został usunięty.": "",
        "Szablon został zaktualizowany.": "",
        "Szablony": "",
        "Szablony adresów URL wpisów w formacie JSON.": "",
        "Szablony URL": "",
        "Szablony URL (JSON)": "",
        "Szczegóły": "",
        "Szczegóły klienta": "",
        "Szczegóły regulaminu": "",
        "Szczegóły techniczne": "",
        "Szczegóły wpisu": "",
        "Szczegóły zamówienia": "",
        "Szerokość": "",
        "Szerokość podglądu": "",
        "Szerokość podglądu: {width} px": "",
        "Szukaj aranżacji": "",
        "Szukaj aranżacji…": "",
        "Szukaj sekcji": "",
        "Szukaj sekcji…": "",
        "Szukaj strony": "",
        "Szukaj widżetu": "",
        "Szukaj widżetu…": "",
        "Ta aranżacja zostanie użyta, jeśli nie przypisano żadnej innej aranżacji do strony.": "",
        "Ta treść jest współdzielona przez wszystkie użycia tego widgetu.": "",
        "Tablet": "",
        "Tagi": "",
        "Tagi nie są widoczne w przypadku zaznaczenia opcji \"Tylko treść artykułu\".": "",
        "Tak": "",
        "Target": "",
        "Te funkcje korzystają z Googlebota. Powyższe ustawienia nie oddzielają ich od zwykłego indeksowania Google Search.": "",
        "Te ustawienia służą do przygotowania wyglądu wiadomości wysyłanych w ramach automatyzacji tej witryny. Wybierz domyślne logo i szablon oraz przygotuj stopkę dla poszczególnych języków, aby e-maile miały spójny wygląd.": "",
        "Tekst": "",
        "Tekst formatowany": "",
        "Tekst prezentowany przy formularzu zapisu do newslettera.": "",
        "Tekst wyświetlany nad galerią": "",
        "Tekst wyświetlany nad gazetką": "",
        "Tekstowy / HTML / JS": "",
        "Telefon": "",
        "Ten komentarz nie ma zgłoszeń do moderacji.": "",
        "Ten komponent nie ma dodatkowych opcji do skonfigurowania.": "",
        "Ten widget nie jest dostępny w żadnej sekcji tej aranżacji.": "",
        "Ten widget nie może zostać przeniesiony do wskazanej sekcji.": "",
        "Ten widżet nie ma dodatkowej konfiguracji": "",
        "Ten wpis jest już wykorzystywany w treści, dlatego jego ustawienia są zablokowane. Możesz sprawdzić obecną konfigurację. Jeśli potrzebujesz innych ustawień, wróć do listy i dodaj nowy link wewnętrzny.": "",
        "Ten wpis jest użyty w aranżacjach:": "",
        "Termin publikacji": "",
        "Testowe": "",
        "Testowe służy do sprawdzania integracji, a Produkcyjne do rzeczywistych płatności. Wprowadź dane punktu POS zgodne z wybranym środowiskiem.": "",
        "Tłumaczenie": "",
        "Tokeny": "",
        "Tonalność tekstu": "",
        "Tonalność Tekstu": "",
        "Top temat został dodany.": "",
        "Top temat został usunięty.": "",
        "Top temat został zaktualizowany.": "",
        "Top tematy": "",
        "Transfer": "",
        "Transfer sekcji": "",
        "Transfer strony": "",
        "Treść": "",
        "Treść aktualności": "",
        "Treść bez nazwy": "",
        "Treść generowana przez AI – sprawdź ją przed wstawieniem.": "",
        "Treść i kolejność slajdów są zarządzane w wybranym rotatorze.": "",
        "Treść komentarza": "",
        "Treść komunikatu wyświetlana na stronie.": "",
        "Treść linku": "",
        "Treść modułu": "",
        "Treść na końcu wiadomości, np. dane kontaktowe firmy. Przygotuj ją osobno dla każdego języka. Puste pole korzysta z domyślnej stopki systemu.": "",
        "Treść nie może być pusta.": "",
        "Treść odpowiedzi": "",
        "Treść opinii wyświetlana na stronie": "",
        "Treść powstaje z sekcji i widgetów aranżacji. Strona nie korzysta z modułu.": "",
        "Treść premium": "",
        "Treść pytania widoczna dla użytkowników": "",
        "Treści": "",
        "Treści uwzględniane w wynikach wyszukiwania witryny.": "",
        "Treści w tym widżecie": "",
        "Treści widgetu zostały zapisane.": "",
        "Tryb „Z metadanych / generatora” zachowuje wartości ustawione dla stron CMS. Wpisy Studio korzystają z wartości weekly i 0.5. Własna wartość zastępuje je we wszystkich sitemapach. Po zapisaniu ustawień wygeneruj sitemapy ponownie.": "",
        "Tryb galerii": "",
        "Tryb oraz struktura sekcji wynikają z wybranego szablonu.": "",
        "Tryb pracy": "",
        "Tryb układu": "",
        "Tryb wyświetlania": "",
        "Tydzień": "",
        "Tylko 404": "",
        "Tylko aktywne": "",
        "Tylko data – 2026-09-04": "",
        "Tylko gdy odpowiedź serwera jest 404": "",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "",
        "Tylko priorytetowe": "",
        "Tylko treść": "",
        "Tylko treść artykułu": "",
        "Tylko zalogowani użytkownicy mogą polubić komentarz.": "",
        "Typ": "",
        "Typ aranżacji": "",
        "Typ autora": "",
        "Typ bannera": "",
        "Typ długości": "",
        "Typ linku": "",
        "Typ obiektu": "",
        "Typ pakietu": "",
        "Typ rankingu": "",
        "Typ strony": "",
        "Typ zestawu": "",
        "Typy aranżacji": "",
        "Tytuł": "",
        "Tytuł aktywnej witryny": "",
        "Tytuł dokumentu": "",
        "Tytuł elementu": "",
        "Tytuł i tagi filmu": "",
        "Tytuł i tagi galerii": "",
        "Tytuł okładki": "",
        "Tytuł pomocniczy": "",
        "Tytuł pomocniczy jest wyświetlany przed tytułem artykułu.": "",
        "Tytuł przerwy technicznej": "",
        "Tytuł strony": "",
        "Tytuł witryny": "",
        "Tytuł wyświetlany na liście filmów i przy materiale wideo.": "",
        "Tytuł wyświetlany na liście galerii i nad jej zawartością.": "",
        "Tytuł, opis i indeksowanie.": "",
        "Uczenie modeli i uzupełnianie odpowiedzi": "",
        "Udostępnia plik publicznie po zapisaniu witryny. Publikacja jest niezależna od ustawień robotów AI.": "",
        "Udostępnia ten artykuł premium bez ograniczania dostępu.": "",
        "Udostępnia witrynę odwiedzającym.": "",
        "Ujednolić terminologię z resztą artykułu": "",
        "Układ dynamiczny": "",
        "Układ statyczny": "",
        "Układ treści oraz moduł obsługujący stronę.": "",
        "Ukryj": "",
        "Ukryj blok": "",
        "Ukryj nazwę w aplikacji": "",
        "Ukryte widgety": "",
        "Ukrywa komentarze przed gośćmi. Wymaga też logowania do dodawania komentarzy i polubień.": "",
        "Ukrywa możliwość komentowania tego artykułu.": "",
        "Ukrywa nagłówek widżetu na stronie. Jego zawartość pozostaje widoczna, a nazwa w panelu nie zmienia się.": "",
        "Ukrywa pozycję w menu bez wyłączania dostępu do strony.": "",
        "Ukrywa przyciski udostępniania artykułu.": "",
        "Umiejscowienie": "",
        "Uprawnienia": "",
        "Upuść widżet w sekcji {name}": "",
        "URL": "",
        "Urządzenie dla kolejności sekcji": "",
        "Usatwienia komentarzy": "",
        "Ustaw kategorię": "",
        "Ustaw nazwę, sposób budowania i rozmieszczenie sekcji.": "",
        "Ustaw również dla wszystkich podstron": "",
        "Ustawienia": "",
        "Ustawienia aranżacji": "",
        "Ustawienia baneru": "",
        "Ustawienia dostępności": "",
        "Ustawienia i wersje regulaminu": "",
        "Ustawienia komentarzy": "",
        "Ustawienia modułu": "",
        "Ustawienia pakietu": "",
        "Ustawienia płatności": "",
        "Ustawienia podstawowe": "",
        "Ustawienia redakcji": "",
        "Ustawienia RSS": "",
        "Ustawienia sekcji": "",
        "Ustawienia sitemap": "",
        "Ustawienia slajdera": "",
        "Ustawienia strony": "",
        "Ustawienia widgetu": "",
        "Ustawienia widżetu": "",
        "Ustawienia witryny": "",
        "Ustawienia z definicji szablonu.": "",
        "Ustawienia zostały zaktualizowane.": "",
        "Ustawienia zostały zapisane.": "",
        "Usuń": "",
        "Usuń artykuł z listy": "",
        "Usuń autora": "",
        "Usuń autora z widżetu": "",
        "Usuń blok": "",
        "Usuń dokument": "",
        "Usuń element": "",
        "Usuń katalog": "",
        "Usuń kategorię": "",
        "Usuń odpowiedź": "",
        "Usuń opinię": "",
        "Usuń plik": "",
        "Usuń powiązanie": "",
        "Usuń powód": "",
        "Usuń powtórzenia i skróć bez utraty sensu": "",
        "Usuń publikację": "",
        "Usuń pytanie": "",
        "Usuń regulamin {name}": "",
        "Usuń sekcję": "",
        "Usuń slajd {number}": "",
        "Usuń słowo": "",
        "Usuń stronę": "",
        "Usuń typ": "",
        "Usuń widget z sekcji": "",
        "Usuń wybrany element": "",
        "Usuń zestaw {name}": "",
        "Usunąć autora z tego widżetu?": "",
        "Usunąć sekcję wraz z umieszczonymi w niej widgetami?": "",
        "Usunąć sekcję?": "",
        "Usunąć sekcję? Jej kolumny przestaną być slotami na widgety w aranżacjach.": "",
        "Usunąć tę sekcję wraz z treścią?": "",
        "Usunąć widżet z tej sekcji?": "",
        "Usunąć własny typ aranżacji? Istniejące aranżacje korzystające z tego typu przestaną mieć poprawny szablon.": "",
        "Usunięcie tej strony spowoduje również usunięcie stron podrzędnych.": "",
        "Usuniesz {count} końcowych kolumn. Przenieś wcześniej ich widżety w aranżacjach korzystających z tego szablonu.": "",
        "usunięto": "",
        "Usunięto widget": "",
        "Utwórz nową": "",
        "Uzupełnij automatyczne reguły witryny o własne instrukcje dla robotów.": "",
        "Uzupełnij fragment o kontekst dla czytelnika": "",
        "Uzupełnij konfigurację po lewej, aby wybrać szablon i rozmieścić widgety.": "",
        "Uzupełnij poprawny adres domenowy w Ustawieniach, aby otworzyć podgląd.": "",
        "Użyta na stronach": "",
        "Użytkownicy mogą zgłaszać komentarze": "",
        "Użytkownicy z bazy": "",
        "Użytkownik dokonał rejestracji samodzielnie.": "",
        "Użytkownik musi potwierdzić adres e-mail.": "",
        "Użytkownik z bazy": "",
        "użytkowników online": "",
        "Użyty w {count} innych aranżacjach": "",
        "Używane jako główna ilustracja artykułu.": "",
        "W aplikacji frontendowej uruchom asystenta komend `npm run edito`, a następnie wklej poniżej zawartość pliku `theme.json` właściwego dla tego szablonu.": "",
        "W drodze": "",
        "W przypadku braku wartości zostanie wyświetlona nazwa strony.": "",
        "W przypadku zaznaczenia opcji \"Artykuł sponsorowany\" lub \"Opinia\", etykieta jest ustawiona automatycznie.": "",
        "W trakcie przygotowania": "",
        "W tym katalogu nie ma jeszcze żadnych stron.": "",
        "W tym miejscu pojawi się treść modułu przypisanego do strony.": "",
        "W widoku opublikowanej wersji edycja jest wyłączona.": "",
        "W wybranych aranżacjach dotychczasowa zawartość tej sekcji zostanie zastąpiona.": "",
        "Walidacja": "",
        "Wartość": "",
        "Wartość długości": "",
        "Wartość jest za długa.": "",
        "Wartość może być za długa.": "",
        "Wartość tekstowa": "",
        "Wczytaj więcej": "",
        "Wczytywanie": "",
        "Wczytywanie formularza…": "",
        "Wczytywanie stron": "",
        "Wczytywanie ustawień strony…": "",
        "Wczytywanie zgód": "",
        "Wczytywanie...": "",
        "Wersja": "",
        "Wersja językowa": "",
        "Wersja językowa treści i widgetów używanych w tej aranżacji.": "",
        "Wersja podglądu": "",
        "Wersja robocza została przywrócona.": "",
        "Wersje": "",
        "Wersje językowe": "",
        "Weryfikacja reCAPTCHA podczas wysyłania formularza.": "",
        "Wewnętrzny": "",
        "Wiadomość została wysłana.": "",
        "Wideo": "",
        "Wideo nie jest jeszcze nigdzie opublikowane.": "",
        "Wideo nie ma ustawionej daty publikacji.": "",
        "Wideo premium": "",
        "Wideo zostało dodane.": "",
        "Wideo zostało usunięte.": "",
        "Wideo zostało zaktualizowane.": "",
        "Widget dynamiczny nie ma kompletnych ustawień modułu.": "",
        "Widget ID": "",
        "Widget jest wyłączony dla tej witryny": "",
        "Widget służy do wczytania ustawień wiadomości email według wybranej witryny i wersji językowej.": "",
        "Widget Studio": "",
        "Widget unikalny może zostać użyty tylko raz": "",
        "Widget został dodany do aranżacji.": "",
        "Widget został skopiowany do wskazanej witryny.": "",
        "Widget został usunięty.": "",
        "Widget został zduplikowany.": "",
        "Widget źródłowy": "",
        "Widoczna tylko dla redaktorów.": "",
        "Widoczna w menu witryny i w drzewie stron.": "",
        "Widoczna wyłącznie w panelu.": "",
        "widoczne": "",
        "Widoczne typy widgetów: %0": "",
        "Widoczność": "",
        "Widoczność w wyszukiwarkach AI": "",
        "Widoczność zdjęcia": "",
        "Widok": "",
        "Widok czołówki - zdjęcie z tytułem": "",
        "Widok narzędzi": "",
        "Widżety": "",
        "Widżety szablonu": "",
        "Więcej": "",
        "Witryna": "",
        "Witryna / Wersja językowa": "",
        "Witryna aktywna": "",
        "Witryna docelowa": "",
        "Witryna domyślna": "",
        "Witryna i język": "",
        "Witryna internetowa": "",
        "Witryna określa dostępne szablony, języki i widgety.": "",
        "Witryna tylko dla zalogowanych użytkowników": "",
        "Witryna została usunięta.": "",
        "Witryna została zapisana.": "",
        "Witryny": "",
        "Wklej wartość Drugi klucz (MD5) z konfiguracji tego samego punktu płatności w PayU.": "",
        "Wklej zawartość pliku JSON z kluczem konta usługi Google Cloud używanego do odczytu statystyk.": "",
        "Włącz ankietę": "",
        "Włącz cache": "",
        "Włącz formularz kontaktowy": "",
        "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "",
        "Włącz publikację pliku llms.txt poniżej.": "",
        "Włącz social media": "",
        "Włącz wszystkie": "",
        "Włącz, aby prezentować zdjęcie wraz z tytułem czołówki.": "",
        "Włącza komentarze dla wybranej witryny i wersji językowej. Pozostałe ustawienia określają dostęp i moderację.": "",
        "Włączenie generowania pliku sitemap.xml dla całej witryny": "",
        "Włączenie protokołu SSL dla tej witryny": "",
        "Włączone (Follow)": "",
        "Włączone (Index)": "",
        "Właściwość ``%0`` aktywnego wpisu": "",
        "Właściwości": "",
        "Własna częstotliwość zmian": "",
        "Własna wartość": "",
        "Własne polecenie": "",
        "Własne reguły": "",
        "Własne wymiary": "",
        "Własny priorytet (od 0 do 1)": "",
        "Wpis został usunięty.": "",
        "Wpis został zaakceptowany.": "",
        "Wpis został zaktualizowany.": "",
        "Wpisy dotyczą tylko tej witryny i zostaną dodane do robots.txt po zapisaniu. Początkowe reguły dotyczą User-agent: *. Dla konkretnego robota dodaj osobną sekcję User-agent. Puste pole zachowuje domyślny plik.": "",
        "Wpisy zostały usunięte.": "",
        "Wpisy zostały zaakceptowane.": "",
        "Wpisz adres linku...": "",
        "Wpisz kod HTML lub skrypt, który ma wyświetlać ten widżet.": "",
        "Wpisz tagi oddzielone przecinkami.": "",
        "Wprowadź link": "",
        "Wprowadź poprawny obiekt JSON.": "",
        "Wskaż stronę docelową i opcjonalne parametry adresu.": "",
        "Wskazany widget nie jest dynamicznym widgetem z formularzem.": "",
        "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "",
        "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "",
        "Wspólne": "",
        "Wstaw do edytora": "",
        "Wstaw do treści": "",
        "Wstęp": "",
        "Wszystkie": "",
        "Wszystkie kolumny będą wyświetlane jedna pod drugą.": "",
        "Wszystkie strony wybranej witryny i języka.": "",
        "Wszystko": "",
        "Wtorek": "",
        "Wybierz": "",
        "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "",
        "Wybierz ankietę": "",
        "Wybierz aranżacje": "",
        "Wybierz artykuł": "",
        "Wybierz autora": "",
        "Wybierz co najmniej jedną kategorię, do której użytkownik może się zapisać.": "",
        "Wybierz czołówkę": "",
        "Wybierz datę": "",
        "Wybierz datę lub wprowadź wartość tekstową": "",
        "Wybierz docelowe aranżacje": "",
        "Wybierz dokument": "",
        "Wybierz domyślną kategorię": "",
        "Wybierz etykietę": "",
        "Wybierz formularz": "",
        "Wybierz gotową czołówkę. Przycisk obok otwiera jej pełną konfigurację.": "",
        "Wybierz grupę banerów, której elementy mają pojawić się w tym widżecie.": "",
        "Wybierz istniejącego użytkownika": "",
        "Wybierz język": "",
        "wybierz katalog": "",
        "Wybierz kategorie": "",
        "Wybierz listę regulaminów": "",
        "Wybierz listę stron": "",
        "Wybierz miejsce dla: %0": "",
        "Wybierz odnośnik": "",
        "Wybierz plik wideo z repozytorium albo wklej adres materiału.": "",
        "Wybierz podpowiedź albo wpisz własne polecenie – zmiana dotyczy wyłącznie zaznaczonego tekstu.": "",
        "Wybierz pole, żeby przejść do edycji w podglądzie.": "",
        "Wybierz regulamin": "",
        "Wybierz sekcję": "",
        "Wybierz sekcję, której nazwę chcesz zmienić.": "",
        "Wybierz sposób działania i prezentacji strony.": "",
        "Wybierz stronę": "",
        "Wybierz stronę do zatwierdzenia.": "",
        "Wybierz szablon": "",
        "Wybierz szablon...": "",
        "Wybierz target": "",
        "Wybierz treść": "",
        "Wybierz typ aranżacji": "",
        "Wybierz typ aranżacji do skonfigurowania.": "",
        "Wybierz użytkownika": "",
        "Wybierz widżet": "",
        "Wybierz widżet, aby sprawdzić jego konfigurację.": "",
        "Wybierz wiele": "",
        "Wybierz witrynę": "",
        "Wybierz witrynę i język": "",
        "Wybierz z listy": "",
        "Wybierz…": "",
        "wybór": "",
        "Wybór kategorii jest wymagany": "",
        "Wybór listy stron": "",
        "Wybór strony": "",
        "Wybrana ikona powinna być kwadratem.": "",
        "Wybrane ankiety zostały usunięte.": "",
        "Wybrane artykuły": "",
        "Wybrane artykuły zostały usunięte.": "",
        "Wybrane czołówki zostały usunięte.": "",
        "Wybrane dokumenty zostały usunięte.": "",
        "Wybrane etykiety zostały usunięte.": "",
        "Wybrane galerie zostały usunięte.": "",
        "Wybrane gazetki zostały usunięte.": "",
        "Wybrane kategorie zostały usunięte.": "",
        "Wybrane linki wewnętrzne zostały usunięte.": "",
        "Wybrane linki zostały usunięte.": "",
        "Wybrane materiały wideo zostały usunięte.": "",
        "Wybrane pytania zostały usunięte.": "",
        "Wybrane regulaminy": "",
        "Wybrane rotatory zostały usunięte.": "",
        "Wybrane strony": "",
        "Wybrane subskrypcje zostały usunięte.": "",
        "Wybrane top tematy zostały usunięte.": "",
        "Wybrane wpisy zostały usunięte.": "",
        "Wybrani autorzy zostali usunięci.": "",
        "Wybranie ankiety jest wymagane": "",
        "Wybranie katalogu jest wymagane": "",
        "Wybranie rotatora jest wymagane": "",
        "Wybranie strony jest wymagane": "",
        "Wybraniue modułu jest wymagane": "",
        "Wybraniue sekcji jest wymagane": "",
        "Wybrano": "",
        "Wybrano etykietę \"Artykuł sponsorowany\".": "",
        "Wybrano etykietę \"Opinia\".": "",
        "Wybrano: {0}": "",
        "Wybrany język": "",
        "Wybrany szablon": "",
        "Wybrany szablon witryny nie udostępnia żadnego układu.": "",
        "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "",
        "Wyczyść": "",
        "Wyczyść wyszukiwanie": "",
        "Wydajność": "",
        "Wygenerowane sloty dla widgetów": "",
        "Wygeneruj definicję szablonu": "",
        "Wygeneruj krótki tytuł": "",
        "Wygeneruj obraz z treści artykułu": "",
        "Wygeneruj tytuł": "",
        "Wygeneruj wstęp": "",
        "Wygeneruj z nazwy autora": "",
        "Wygląd": "",
        "Wygląd wiadomości e-mail": "",
        "Wyjaśnij prostym językiem najważniejsze pojęcia z treści": "",
        "Wykonawca": "",
        "Wyłącz cenę": "",
        "Wyłącz cenę z historii": "",
        "Wyłącz komentarze": "",
        "Wyłącz skupienie": "",
        "Wyłącz udostępnianie": "",
        "Wyłącz wszystkie": "",
        "Wyłącz, aby strona nie była dostępna w witrynie.": "",
        "Wyłącz, aby ukryć widżet na stronie bez usuwania jego ustawień i zawartości.": "",
        "Wyłączona": "",
        "Wyłączone (NoFollow)": "",
        "Wyłączone (NoIndex)": "",
        "Wyłączone komentarze": "",
        "Wyłączone przez:": "",
        "Wyłączone udostępnianie": "",
        "Wyłączono focus widgetu": "",
        "Wyłączony autor nie jest widoczny na stronie.": "",
        "Wyliczana automatycznie (Omnibus).": "",
        "Wymaga logowania przed wyświetleniem treści witryny.": "",
        "Wymaga ponownej akceptacji": "",
        "Wymagaj ponownej akceptacji po zmianach": "",
        "Wymagane": "",
        "Wymagane jest wybranie sekcji": "",
        "Wymagane jest wybranie wersji językowej": "",
        "Wymagane jest wybranie witryny": "",
        "Wymagane jest wybranie zestawu regulaminów": "",
        "Wymiar": "",
        "Wymiary strony": "",
        "Wyniki": "",
        "Wyniki ankiety": "",
        "Wyniki pojawią się po pierwszym oddanym głosie.": "",
        "Wyniki_": "",
        "Wypisz najważniejsze wnioski": "",
        "Wypisz znalezione błędy bez zmiany treści": "",
        "Wyrażone zgody": "",
        "Wyróżnia artykuł przy ustalaniu kolejności publikacji.": "",
        "Wyróżnik artykułu na listingach": "",
        "Wysłane": "",
        "Wyślij wiadomość": "",
        "Wysoki": "",
        "Wysokość": "",
        "Wystąpił błąd": "",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "",
        "Wyświetla się, gdy adres nie prowadzi do istniejącej strony. Jest automatycznie ukryta w nawigacji.": "",
        "Wyświetlaj listę artykułów z miniaturką zdjęcia": "",
        "Wyświetlaj nazwę widgetu": "",
        "Wyświetlaj opinie z tłem": "",
        "Wyświetlaj tytuł": "",
        "Wyświetlana jako przekreślona.": "",
        "Wyświetlane na listingu i nad treścią": "",
        "Wyświetlane przy tym artykule": "",
        "Wyświetlany na listingach i w stopce artykułu.": "",
        "Wyświetlenia": "",
        "Wyszukaj": "",
        "Wyszukaj albo dodaj nową kategorię": "",
        "Wyszukaj albo dodaj nowy tag": "",
        "Wyszukaj autora i kliknij plus. Wybrane osoby pojawią się na liście widżetu.": "",
        "Wyszukaj autora...": "",
        "Wyszukaj czołówkę...": "",
        "Wyszukaj czołówkę…": "",
        "Wyszukaj kategorię": "",
        "Wyszukaj kategorię...": "",
        "Wyszukaj regulamin…": "",
        "Wyszukaj treść": "",
        "Wyszukaj widżet": "",
        "Wyszukiwanie zwraca tylko zaakceptowane wersje regulaminów.": "",
        "Wyżej": "",
        "Wznawiam podgląd...": "",
        "Wzór shortcode został usunięty.": "",
        "Wzór shortcode został zapisany.": "",
        "Wzory": "",
        "YouTube (ID)": "",
        "Z metadanych / generatora": "",
        "Zaakceptowane": "",
        "Zaakceptowane wersje": "",
        "Zaakceptowany": "",
        "Zaawansowane polecenia": "",
        "Zaawansowany": "",
        "zacznij pisać aby wyszukać ankietę...": "",
        "zacznij pisać aby wyszukać ankiety...": "",
        "zacznij pisać aby wyszukać artykuł...": "",
        "zacznij pisać aby wyszukać autora...": "",
        "zacznij pisać aby wyszukać autora…": "",
        "zacznij pisać aby wyszukać dokument...": "",
        "zacznij pisać aby wyszukać galerię...": "",
        "zacznij pisać aby wyszukać grupę...": "",
        "zacznij pisać aby wyszukać kategorię...": "",
        "zacznij pisać aby wyszukać rotator...": "",
        "zacznij pisać aby wyszukać rotator…": "",
        "zacznij pisać aby wyszukać wideo...": "",
        "Zacznij pisać, aby wyszukać autora…": "",
        "Zacznij pisać, aby wyszukać grupę…": "",
        "Zacznij pisać, aby wyszukać użytkownika…": "",
        "Zadaj pytanie lub wpisz polecenie": "",
        "Zaimportowano listę przekierowań.": "",
        "Zakończone": "",
        "Zakres": "",
        "Załączniki": "",
        "Załączniki premium": "",
        "Zamiany zostały zapisane.": "",
        "Zamknięto edytor formularza": "",
        "Zamknięto edytor wpisu": "",
        "Zamknij": "",
        "Zamknij edytor": "",
        "Zamknij Live Design": "",
        "Zamknij panel skrótów albo boczny panel": "",
        "zamówień": "",
        "zamówienia": "",
        "Zamówienia": "",
        "zamówienie": "",
        "Zamówienie": "",
        "Zamówienie zostało zaktualizowane.": "",
        "Zamówiony pakiet": "",
        "Zapisano ustawienia kanałów RSS.": "",
        "Zapisz": "",
        "Zapisz aranżację": "",
        "Zapisz i wróć": "",
        "Zapisz lub odrzuć zmiany, aby zmienić witrynę.": "",
        "Zapisz ustawienia": "",
        "Zapisz zmiany": "",
        "Zaplanowana zmiana ceny": "",
        "Zaplanowane": "",
        "Zaproponuj trzy śródtytuły dla tej treści": "",
        "Zaproponuj tytuł i lead dla tej treści": "",
        "Zapytanie EQL": "",
        "Zarejestrowani użytkownicy": "",
        "Zarządzaj dostępem do strony w panelu.": "",
        "Zarządzaj dostępem do tej witryny w panelu administracyjnym.": "",
        "Zarządzaj kategoriami": "",
        "Zarządzanie": "",
        "Zarządzanie witrynami": "",
        "Zasady zgłaszania treści przez użytkowników.": "",
        "Zasoby": "",
        "Zastąp": "",
        "Zastąp fragment": "",
        "Zastosuj": "",
        "Zatwierdź": "",
        "Zawartość sekcji została zastąpiona w wybranych aranżacjach.": "",
        "Zawiera sekcje": "",
        "Zawierające jeden z wybranych tagów": "",
        "Zawsze": "",
        "Zaznacz tekst, aby wykonać operację AI.": "",
        "Zaznacz wszystkie": "",
        "Zaznaczone": "",
        "Zaznaczony fragment": "",
        "Zbuduj zawartość strony z sekcji i elementów.": "",
        "Zdjęcia": "",
        "Zdjęcia dostępne w ramach treści premium. Kolejność zmienisz przeciąganiem.": "",
        "Zdjęcia galerii": "",
        "Zdjęcie": "",
        "Zdjęcie dla tabletów": "",
        "Zdjęcie dla urządzeń mobilnych": "",
        "Zdjęcie główne": "",
        "Zdjęcie główne nie jest widoczne w przypadku zaznaczenia opcji \"Tylko treść artykułu\".": "",
        "Zdjęcie na okładce": "",
        "Zdjęcie w tle": "",
        "Zdjęcie/ikonka": "",
        "Zduplikowano widget": "",
        "Zestaw": "",
        "Zestaw niestandardowy": "",
        "Zestaw regulaminów prezentowany przy zapisie do subskrypcji.": "",
        "Zestaw został dodany.": "",
        "Zestaw został zaktualizowany.": "",
        "Zewnętrzne skrypty statystyk": "",
        "Zewnętrzne skrypty targetujące": "",
        "Zewnętrzny": "",
        "Zewnętrzny serwis": "",
        "Zezwalaj na odkrywanie treści": "",
        "Zezwalaj na używanie treści przez AI": "",
        "Zgłaszanie": "",
        "Zgłaszanie komentarzy": "",
        "Zgłaszanie tylko po zalogowaniu": "",
        "zgłoszeń": "",
        "Zgłoszenia": "",
        "Zmiana formularza nie będzie możliwa po zapisaniu shortcode.": "",
        "Zmiana nazwy nie zmienia identyfikatora sekcji ani jej umiejscowienia.": "",
        "Zmiana przenosi kategorię wraz z podkategoriami.": "",
        "Zmiana symbolu powoduje również zmianę adresu URL.": "",
        "Zmiana trybu układu": "",
        "Zmiana została zapisana.": "",
        "Zmiany w tym widoku bezpośrednio wpływają na działanie aplikacji frontend. Upewnij się, że modyfikacje są przemyślane i uzasadnione.": "",
        "Zmiany widżetu będą widoczne również w tych aranżacjach.": "",
        "Zmiany wpływają na frontend": "",
        "Zmiany zostały zapisane.": "",
        "Zmień daty publikacji": "",
        "Zmień nazwę": "",
        "Zmień nazwę katalogu": "",
        "Zmień nazwę kategorii": "",
        "Zmień tonalność i dodaj bezpośredni zwrot do czytelnika": "",
        "Zmień tonalność zaznaczonego fragmentu i uprość zdania": "",
        "Zmień tonalność zaznaczonego fragmentu, pozostawiając terminologię": "",
        "Zmień tonalność zaznaczonego fragmentu, zachowując treść": "",
        "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "",
        "Zmieniono kolejność widgetów": "",
        "Zmienne": "",
        "Znajdź typ widgetu...": "",
        "Znajdź typ widżetu": "",
        "Znajdź widżet": "",
        "Znajdź widżet…": "",
        "znaków": "",
        "Zobacz przed opublikowaniem": "",
        "Zrezygnowano": "",
        "Źródło danych": "",
        "Źródło URL": "",
        "Źródło wideo": "",
        "Źródło wideo premium": "",
        "Zwięzła wersja do kafelków i list artykułów.": "",
        "Zwiń panel podglądu": "",
        "Zwrot do nadawcy": ""
    }
};
